import axios from 'axios'
import { api_lp, api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'
import router from '../../router'

const kplhStore = {
  namespaced: true,
  state: () => ({
    is_preview: false,
    sipm_preview: false,

    is_vendor_done: false,
    is_vendor_feedback: false,

    is_sipm_review: false,
    is_sipm_validation: false,

    is_hse_validation: false,
    is_hse_approved: false,
    is_head_validation: false,
    is_head_approved: true,

    // modal in KPLH
    modal_add_kbug: false,
    modal_add_bidang_usaha_gems: false,
    //

    register_step: true,
    profile_step: false,
    grupah_step: false,
    grupi1_step: false,
    grupi2_step: false,
    grupjm_step: false,
    end_step: false,
    registerDone: false,

    globalLoading: false,
    activeLanding: process.env.VUE_APP_KPLH_ACTIVE_LANDING,
    tingkat_resiko: 0,

    user_id: null,
    request_id: null,
    vendor_ref: null,
    pendaftaran_id: null,
    tujuan_pendaftaran_id: null,
    bidang_usaha_id: null,
    type_pendaftaran_id: null,
    kplh_choosed_bu: '',
    addedKbli: [],
    addedBidangUsahaGems: [],

    pic_phone_code: '',
    vendor_name: '',
    vendor_address: '',
    jenis_badan_usaha: '',
    bidang_usaha: [],
    company_gems_list: [],
    hasil_tingkat_resiko: '',
    choosed_company: '',

    pic_name: '',
    pic_position: '',
    pic_email: '',
    pic_phone: '',

    note_a_1: '',
    note_a_2: '',

    note_b_1: '',
    note_b_2: '',
    note_b_3: '',
    note_b_4: '',

    note_c_1: '',
    note_c_2: '',

    note_d_1: '',
    note_d_2: '',

    note_e_1: '',
    note_e_2: '',
    note_e_3: '',

    note_f_1: '',
    note_f_2: '',
    note_f_3: '',
    note_f_4: '',

    note_g_1: '',
    note_g_2: '',
    note_g_3: '',

    note_h_1: '',

    note_i1_1: '',
    note_i1_2: '',

    note_i2_1: '',
    note_i2_2: '',
    note_i2_3: '',
    note_i2_4: '',

    note_i31_1: '',
    note_i31_2: '',
    note_i31_3: '',
    note_i31_4: '',

    note_i32_1: '',

    note_i33_1: '',
    note_i33_2: '',

    note_i34_1: '',
    note_i34_2: '',
    note_i34_3: '',

    note_i4_1: '',
    note_i4_2: '',
    note_i4_3: '',

    note_i51_1: '',
    note_i51_2: '',

    note_i52_1: '',
    note_i52_2: '',
    note_i52_3: '',

    note_i53_1: '',
    note_i53_2: '',

    note_i54_1: '',
    note_i54_2: '',
    note_i54_3: '',

    note_i6_1: '',
    note_i6_2: '',

    note_i7_1: '',
    note_i7_2: '',

    note_i8_1: '',
    note_i8_2: '',
    note_i8_3: '',

    note_i9_1: '',
    note_i9_2: '',

    note_j_1: '',
    note_j_2: '',
    note_j_3: '',
    note_j_4: '',

    note_k_1: '',
    note_k_2: '',

    note_l_1: '',
    note_l_2: '',
    note_l_3: '',

    note_m_1: '',
    note_m_2: '',
    note_m_3: '',

    internal_note_a_1: '',
    internal_note_a_2: '',

    internal_note_b_1: '',
    internal_note_b_2: '',
    internal_note_b_3: '',
    internal_note_b_4: '',

    internal_note_c_1: '',
    internal_note_c_2: '',

    internal_note_d_1: '',
    internal_note_d_2: '',

    internal_note_e_1: '',
    internal_note_e_2: '',
    internal_note_e_3: '',

    internal_note_f_1: '',
    internal_note_f_2: '',
    internal_note_f_3: '',
    internal_note_f_4: '',

    internal_note_g_1: '',
    internal_note_g_2: '',
    internal_note_g_3: '',

    internal_note_h_1: '',

    internal_note_i1_1: '',
    internal_note_i1_2: '',

    internal_note_i2_1: '',
    internal_note_i2_2: '',
    internal_note_i2_3: '',
    internal_note_i2_4: '',

    internal_note_i31_1: '',
    internal_note_i31_2: '',
    internal_note_i31_3: '',
    internal_note_i31_4: '',

    internal_note_i32_1: '',

    internal_note_i33_1: '',
    internal_note_i33_2: '',

    internal_note_i34_1: '',
    internal_note_i34_2: '',
    internal_note_i34_3: '',

    internal_note_i4_1: '',
    internal_note_i4_2: '',
    internal_note_i4_3: '',

    internal_note_i51_1: '',
    internal_note_i51_2: '',

    internal_note_i52_1: '',
    internal_note_i52_2: '',
    internal_note_i52_3: '',

    internal_note_i53_1: '',
    internal_note_i53_2: '',

    internal_note_i54_1: '',
    internal_note_i54_2: '',
    internal_note_i54_3: '',

    internal_note_i6_1: '',
    internal_note_i6_2: '',

    internal_note_i7_1: '',
    internal_note_i7_2: '',

    internal_note_i8_1: '',
    internal_note_i8_2: '',
    internal_note_i8_3: '',

    internal_note_i9_1: '',
    internal_note_i9_2: '',

    internal_note_j_1: '',
    internal_note_j_2: '',
    internal_note_j_3: '',
    internal_note_j_4: '',

    internal_note_k_1: '',
    internal_note_k_2: '',

    internal_note_l_1: '',
    internal_note_l_2: '',
    internal_note_l_3: '',

    internal_note_m_1: '',
    internal_note_m_2: '',
    internal_note_m_3: '',

    bobot_a_1: 2,
    bobot_a_2: 2,

    bobot_b_1: 2,
    bobot_b_2: 2,
    bobot_b_3: 3,
    bobot_b_4: 3,

    bobot_c_1: 2,
    bobot_c_2: 2,

    bobot_d_1: 2,
    bobot_d_2: 2,

    bobot_e_1: 2,
    bobot_e_2: 2,
    bobot_e_3: 4,

    bobot_f_1: 4,
    bobot_f_2: 2,
    bobot_f_3: 3,
    bobot_f_4: 2,

    bobot_g_1: 2,
    bobot_g_2: 2,
    bobot_g_3: 2,

    bobot_h_1: 4,

    bobot_i1_1: 2,
    bobot_i1_2: 2,

    bobot_i2_1: 2,
    bobot_i2_2: 2,
    bobot_i2_3: 2,
    bobot_i2_4: 2,

    bobot_i31_1: 2,
    bobot_i31_2: 2,
    bobot_i31_3: 2,
    bobot_i31_4: 2,

    bobot_i32_1: 4,

    bobot_i33_1: 1,
    bobot_i33_2: 1,

    bobot_i34_1: 1,
    bobot_i34_2: 1,
    bobot_i34_3: 1,

    bobot_i4_1: 2,
    bobot_i4_2: 2,
    bobot_i4_3: 1,

    bobot_i51_1: 3,
    bobot_i51_2: 3,

    bobot_i52_1: 2,
    bobot_i52_2: 2,
    bobot_i52_3: 2,

    bobot_i53_1: 2,
    bobot_i53_2: 2,

    bobot_i54_1: 2,
    bobot_i54_2: 2,
    bobot_i54_3: 2,

    bobot_i6_1: 3,
    bobot_i6_2: 3,

    bobot_i7_1: 4,
    bobot_i7_2: 2,

    bobot_i8_1: 4,
    bobot_i8_2: 2,
    bobot_i8_3: 3,

    bobot_i9_1: 3,
    bobot_i9_2: 2,

    bobot_j_1: 2,
    bobot_j_2: 2,
    bobot_j_3: 2,
    bobot_j_4: 2,

    bobot_k_1: 2,
    bobot_k_2: 2,

    bobot_l_1: 2,
    bobot_l_2: 2,
    bobot_l_3: 2,

    bobot_m_1: 2,
    bobot_m_2: 3,
    bobot_m_3: 3,

    value_a_1: '',
    value_a_2: '',

    value_b_1: '',
    value_b_2: '',
    value_b_3: '',
    value_b_4: '',

    value_c_1: '',
    value_c_2: '',

    value_d_1: '',
    value_d_2: '',

    value_e_1: '',
    value_e_2: '',
    value_e_3: '',

    value_f_1: '',
    value_f_2: '',
    value_f_3: '',
    value_f_4: '',

    value_g_1: '',
    value_g_2: '',
    value_g_3: '',

    value_h_1: '',

    value_i1_1: '',
    value_i1_2: '',

    value_i2_1: '',
    value_i2_2: '',
    value_i2_3: '',
    value_i2_4: '',

    value_i31_1: '',
    value_i31_2: '',
    value_i31_3: '',
    value_i31_4: '',

    value_i32_1: '',

    value_i33_1: '',
    value_i33_2: '',

    value_i34_1: '',
    value_i34_2: '',
    value_i34_3: '',

    value_i4_1: '',
    value_i4_2: '',
    value_i4_3: '',

    value_i51_1: '',
    value_i51_2: '',

    value_i52_1: '',
    value_i52_2: '',
    value_i52_3: '',

    value_i53_1: '',
    value_i53_2: '',

    value_i54_1: '',
    value_i54_2: '',
    value_i54_3: '',

    value_i6_1: '',
    value_i6_2: '',

    value_i7_1: '',
    value_i7_2: '',

    value_i8_1: '',
    value_i8_2: '',
    value_i8_3: '',

    value_i9_1: '',
    value_i9_2: '',

    value_j_1: '',
    value_j_2: '',
    value_j_3: '',
    value_j_4: '',

    value_k_1: '',
    value_k_2: '',

    value_l_1: '',
    value_l_2: '',
    value_l_3: '',

    value_m_1: '',
    value_m_2: '',
    value_m_3: '',

    attachment_a_1: '',
    attachment_a_2: '',

    attachment_b_1: '',
    attachment_b_2: '',
    attachment_b_3: '',
    attachment_b_4: '',

    attachment_c_1: '',
    attachment_c_2: '',

    attachment_d_1: '',
    attachment_d_2: '',

    attachment_e_1: '',
    attachment_e_2: '',
    attachment_e_3: '',

    attachment_f_1: '',
    attachment_f_2: '',
    attachment_f_3: '',
    attachment_f_4: '',

    attachment_g_1: '',
    attachment_g_2: '',
    attachment_g_3: '',

    attachment_h_1: '',

    attachment_i1_1: '',
    attachment_i1_2: '',

    attachment_i2_1: '',
    attachment_i2_2: '',
    attachment_i2_3: '',
    attachment_i2_4: '',

    attachment_i31_1: '',
    attachment_i31_2: '',
    attachment_i31_3: '',
    attachment_i31_4: '',

    attachment_i32_1: '',

    attachment_i33_1: '',
    attachment_i33_2: '',

    attachment_i34_1: '',
    attachment_i34_2: '',
    attachment_i34_3: '',

    attachment_i4_1: '',
    attachment_i4_2: '',
    attachment_i4_3: '',

    attachment_i51_1: '',
    attachment_i51_2: '',

    attachment_i52_1: '',
    attachment_i52_2: '',
    attachment_i52_3: '',

    attachment_i53_1: '',
    attachment_i53_2: '',

    attachment_i54_1: '',
    attachment_i54_2: '',
    attachment_i54_3: '',

    attachment_i6_1: '',
    attachment_i6_2: '',

    attachment_i7_1: '',
    attachment_i7_2: '',

    attachment_i8_1: '',
    attachment_i8_2: '',
    attachment_i8_3: '',

    attachment_i9_1: '',
    attachment_i9_2: '',

    attachment_j_1: '',
    attachment_j_2: '',
    attachment_j_3: '',
    attachment_j_4: '',

    attachment_k_1: '',
    attachment_k_2: '',

    attachment_l_1: '',
    attachment_l_2: '',
    attachment_l_3: '',

    attachment_m_1: '',
    attachment_m_2: '',
    attachment_m_3: '',

    head_hse_options: [],
    ktt_options: [],
    notes_options: '',
    catatan: '',

    bobot_kritis: 159,
    bobot_tinggi: 122,
    bobot_sedang: 41,
    bobot_rendah: 12,
    // total_bobot: 0,

    total_kritis: 0,
    total_tinggi: 0,
    total_sedang: 0,
    total_rendah: 0,
    grand_total: 0,
    final_result_notes: '',
    tdd_head_hse: '',
    tdd_ktt: '',

    is_catatan_head_open: false,
  }),
  mutations: {
    SET_ACTIVE_PAGE(state, payload) {
      state.activeLanding = payload.name
    },
    SET_JUMP_STATUS(state) {
      state.register_step = true
      state.profile_step = true
      state.grupah_step = true
      state.grupi1_step = true
      state.grupi2_step = true
      state.grupjm_step = true
      state.end_step = true
    },
    SET_KPLH_FORM(state, payload) {
      console.log('kplh form: ', payload)
      state[payload.name] = payload.value
    },
    SET_UPDATE_PENILAIAN(state, payload) {
      ;``
      console.log('update kplh penilaian: ', payload.catatan)
      const note_ah = JSON.parse(payload.kplh_note_ah)
      const note_i1 = JSON.parse(payload.kplh_note_i1)
      const note_i2 = JSON.parse(payload.kplh_note_i2)
      const note_jm = JSON.parse(payload.kplh_note_jm)
      const value_ah = JSON.parse(payload.kplh_value_ah)
      const value_i1 = JSON.parse(payload.kplh_value_i1)
      const value_i2 = JSON.parse(payload.kplh_value_i2)
      const value_jm = JSON.parse(payload.kplh_value_jm)

      state.tdd_head_hse = payload.head_hse_id
      state.tdd_ktt = payload.ktt_id
      state.final_result_notes = payload.final_result
      state.catatan = payload.catatan

      state.note_a_1 = note_ah.note_a_1
      state.note_a_2 = note_ah.note_a_2
      state.note_b_1 = note_ah.note_b_1
      state.note_b_2 = note_ah.note_b_2
      state.note_b_3 = note_ah.note_b_3
      state.note_b_4 = note_ah.note_b_4
      state.note_c_1 = note_ah.note_c_1
      state.note_c_2 = note_ah.note_c_2
      state.note_d_1 = note_ah.note_d_1
      state.note_d_2 = note_ah.note_d_2
      state.note_e_1 = note_ah.note_e_1
      state.note_e_2 = note_ah.note_e_2
      state.note_e_3 = note_ah.note_e_3
      state.note_f_1 = note_ah.note_f_1
      state.note_f_2 = note_ah.note_f_2
      state.note_f_3 = note_ah.note_f_3
      state.note_f_4 = note_ah.note_f_4
      state.note_g_1 = note_ah.note_g_1
      state.note_g_2 = note_ah.note_g_2
      state.note_g_3 = note_ah.note_g_3
      state.note_h_1 = note_ah.note_h_1

      state.note_i1_1 = note_i1.note_i1_1
      state.note_i1_2 = note_i1.note_i1_2
      state.note_i2_1 = note_i1.note_i2_1
      state.note_i2_2 = note_i1.note_i2_2
      state.note_i2_3 = note_i1.note_i2_3
      state.note_i2_4 = note_i1.note_i2_4
      state.note_i31_1 = note_i1.note_i31_1
      state.note_i31_2 = note_i1.note_i31_2
      state.note_i31_3 = note_i1.note_i31_3
      state.note_i31_4 = note_i1.note_i31_4
      state.note_i32_1 = note_i1.note_i32_1
      state.note_i33_1 = note_i1.note_i33_1
      state.note_i33_2 = note_i1.note_i33_2
      state.note_i34_1 = note_i1.note_i34_1
      state.note_i34_2 = note_i1.note_i34_2
      state.note_i34_3 = note_i1.note_i34_3
      state.note_i4_1 = note_i1.note_i4_1
      state.note_i4_2 = note_i1.note_i4_2
      state.note_i4_3 = note_i1.note_i4_3

      state.note_i51_1 = note_i2.note_i51_1
      state.note_i51_2 = note_i2.note_i51_2
      state.note_i52_1 = note_i2.note_i52_1
      state.note_i52_2 = note_i2.note_i52_2
      state.note_i52_3 = note_i2.note_i52_3
      state.note_i53_1 = note_i2.note_i53_1
      state.note_i53_2 = note_i2.note_i53_2
      state.note_i54_1 = note_i2.note_i54_1
      state.note_i54_2 = note_i2.note_i54_2
      state.note_i54_3 = note_i2.note_i54_3
      state.note_i6_1 = note_i2.note_i6_1
      state.note_i6_2 = note_i2.note_i6_2
      state.note_i7_1 = note_i2.note_i7_1
      state.note_i7_2 = note_i2.note_i7_2
      state.note_i8_1 = note_i2.note_i8_1
      state.note_i8_2 = note_i2.note_i8_2
      state.note_i8_3 = note_i2.note_i8_3
      state.note_i9_1 = note_i2.note_i9_1
      state.note_i9_2 = note_i2.note_i9_2

      state.note_j_1 = note_jm.note_j_1
      state.note_j_2 = note_jm.note_j_2
      state.note_j_3 = note_jm.note_j_3
      state.note_j_4 = note_jm.note_j_4
      state.note_k_1 = note_jm.note_k_1
      state.note_k_2 = note_jm.note_k_2
      state.note_l_1 = note_jm.note_l_1
      state.note_l_2 = note_jm.note_l_2
      state.note_l_3 = note_jm.note_l_3
      state.note_m_1 = note_jm.note_m_1
      state.note_m_2 = note_jm.note_m_2
      state.note_m_3 = note_jm.note_m_3

      state.internal_note_a_1 = note_ah.internal_note_a_1
      state.internal_note_a_2 = note_ah.internal_note_a_2
      state.internal_note_b_1 = note_ah.internal_note_b_1
      state.internal_note_b_2 = note_ah.internal_note_b_2
      state.internal_note_b_3 = note_ah.internal_note_b_3
      state.internal_note_b_4 = note_ah.internal_note_b_4
      state.internal_note_c_1 = note_ah.internal_note_c_1
      state.internal_note_c_2 = note_ah.internal_note_c_2
      state.internal_note_d_1 = note_ah.internal_note_d_1
      state.internal_note_d_2 = note_ah.internal_note_d_2
      state.internal_note_e_1 = note_ah.internal_note_e_1
      state.internal_note_e_2 = note_ah.internal_note_e_2
      state.internal_note_e_3 = note_ah.internal_note_e_3
      state.internal_note_f_1 = note_ah.internal_note_f_1
      state.internal_note_f_2 = note_ah.internal_note_f_2
      state.internal_note_f_3 = note_ah.internal_note_f_3
      state.internal_note_f_4 = note_ah.internal_note_f_4
      state.internal_note_g_1 = note_ah.internal_note_g_1
      state.internal_note_g_2 = note_ah.internal_note_g_2
      state.internal_note_g_3 = note_ah.internal_note_g_3
      state.internal_note_h_1 = note_ah.internal_note_h_1

      state.internal_note_i1_1 = note_i1.internal_note_i1_1
      state.internal_note_i1_2 = note_i1.internal_note_i1_2
      state.internal_note_i2_1 = note_i1.internal_note_i2_1
      state.internal_note_i2_2 = note_i1.internal_note_i2_2
      state.internal_note_i2_3 = note_i1.internal_note_i2_3
      state.internal_note_i2_4 = note_i1.internal_note_i2_4
      state.internal_note_i31_1 = note_i1.internal_note_i31_1
      state.internal_note_i31_2 = note_i1.internal_note_i31_2
      state.internal_note_i31_3 = note_i1.internal_note_i31_3
      state.internal_note_i31_4 = note_i1.internal_note_i31_4
      state.internal_note_i32_1 = note_i1.internal_note_i32_1
      state.internal_note_i33_1 = note_i1.internal_note_i33_1
      state.internal_note_i33_2 = note_i1.internal_note_i33_2
      state.internal_note_i34_1 = note_i1.internal_note_i34_1
      state.internal_note_i34_2 = note_i1.internal_note_i34_2
      state.internal_note_i34_3 = note_i1.internal_note_i34_3
      state.internal_note_i4_1 = note_i1.internal_note_i4_1
      state.internal_note_i4_2 = note_i1.internal_note_i4_2
      state.internal_note_i4_3 = note_i1.internal_note_i4_3

      state.internal_note_i51_1 = note_i2.internal_note_i51_1
      state.internal_note_i51_2 = note_i2.internal_note_i51_2
      state.internal_note_i52_1 = note_i2.internal_note_i52_1
      state.internal_note_i52_2 = note_i2.internal_note_i52_2
      state.internal_note_i52_3 = note_i2.internal_note_i52_3
      state.internal_note_i53_1 = note_i2.internal_note_i53_1
      state.internal_note_i53_2 = note_i2.internal_note_i53_2
      state.internal_note_i54_1 = note_i2.internal_note_i54_1
      state.internal_note_i54_2 = note_i2.internal_note_i54_2
      state.internal_note_i54_3 = note_i2.internal_note_i54_3
      state.internal_note_i6_1 = note_i2.internal_note_i6_1
      state.internal_note_i6_2 = note_i2.internal_note_i6_2
      state.internal_note_i7_1 = note_i2.internal_note_i7_1
      state.internal_note_i7_2 = note_i2.internal_note_i7_2
      state.internal_note_i8_1 = note_i2.internal_note_i8_1
      state.internal_note_i8_2 = note_i2.internal_note_i8_2
      state.internal_note_i8_3 = note_i2.internal_note_i8_3
      state.internal_note_i9_1 = note_i2.internal_note_i9_1
      state.internal_note_i9_2 = note_i2.internal_note_i9_2

      state.internal_note_j_1 = note_jm.internal_note_j_1
      state.internal_note_j_2 = note_jm.internal_note_j_2
      state.internal_note_j_3 = note_jm.internal_note_j_3
      state.internal_note_j_4 = note_jm.internal_note_j_4
      state.internal_note_k_1 = note_jm.internal_note_k_1
      state.internal_note_k_2 = note_jm.internal_note_k_2
      state.internal_note_l_1 = note_jm.internal_note_l_1
      state.internal_note_l_2 = note_jm.internal_note_l_2
      state.internal_note_l_3 = note_jm.internal_note_l_3
      state.internal_note_m_1 = note_jm.internal_note_m_1
      state.internal_note_m_2 = note_jm.internal_note_m_2
      state.internal_note_m_3 = note_jm.internal_note_m_3

      state.value_a_1 = value_ah.value_a_1
      state.value_a_2 = value_ah.value_a_2
      state.value_b_1 = value_ah.value_b_1
      state.value_b_2 = value_ah.value_b_2
      state.value_b_3 = value_ah.value_b_3
      state.value_b_4 = value_ah.value_b_4
      state.value_c_1 = value_ah.value_c_1
      state.value_c_2 = value_ah.value_c_2
      state.value_d_1 = value_ah.value_d_1
      state.value_d_2 = value_ah.value_d_2
      state.value_e_1 = value_ah.value_e_1
      state.value_e_2 = value_ah.value_e_2
      state.value_e_3 = value_ah.value_e_3
      state.value_f_1 = value_ah.value_f_1
      state.value_f_2 = value_ah.value_f_2
      state.value_f_3 = value_ah.value_f_3
      state.value_f_4 = value_ah.value_f_4
      state.value_g_1 = value_ah.value_g_1
      state.value_g_2 = value_ah.value_g_2
      state.value_g_3 = value_ah.value_g_3
      state.value_h_1 = value_ah.value_h_1

      state.value_i1_1 = value_i1.value_i1_1
      state.value_i1_2 = value_i1.value_i1_2
      state.value_i2_1 = value_i1.value_i2_1
      state.value_i2_2 = value_i1.value_i2_2
      state.value_i2_3 = value_i1.value_i2_3
      state.value_i2_4 = value_i1.value_i2_4
      state.value_i31_1 = value_i1.value_i31_1
      state.value_i31_2 = value_i1.value_i31_2
      state.value_i31_3 = value_i1.value_i31_3
      state.value_i31_4 = value_i1.value_i31_4
      state.value_i32_1 = value_i1.value_i32_1
      state.value_i33_1 = value_i1.value_i33_1
      state.value_i33_2 = value_i1.value_i33_2
      state.value_i34_1 = value_i1.value_i34_1
      state.value_i34_2 = value_i1.value_i34_2
      state.value_i34_3 = value_i1.value_i34_3
      state.value_i4_1 = value_i1.value_i4_1
      state.value_i4_2 = value_i1.value_i4_2
      state.value_i4_3 = value_i1.value_i4_3

      state.value_i51_1 = value_i2.value_i51_1
      state.value_i51_2 = value_i2.value_i51_2
      state.value_i52_1 = value_i2.value_i52_1
      state.value_i52_2 = value_i2.value_i52_2
      state.value_i52_3 = value_i2.value_i52_3
      state.value_i53_1 = value_i2.value_i53_1
      state.value_i53_2 = value_i2.value_i53_2
      state.value_i54_1 = value_i2.value_i54_1
      state.value_i54_2 = value_i2.value_i54_2
      state.value_i54_3 = value_i2.value_i54_3
      state.value_i6_1 = value_i2.value_i6_1
      state.value_i6_2 = value_i2.value_i6_2
      state.value_i7_1 = value_i2.value_i7_1
      state.value_i7_2 = value_i2.value_i7_2
      state.value_i8_1 = value_i2.value_i8_1
      state.value_i8_2 = value_i2.value_i8_2
      state.value_i8_3 = value_i2.value_i8_3
      state.value_i9_1 = value_i2.value_i9_1
      state.value_i9_2 = value_i2.value_i9_2

      state.value_j_1 = value_jm.value_j_1
      state.value_j_2 = value_jm.value_j_2
      state.value_j_3 = value_jm.value_j_3
      state.value_j_4 = value_jm.value_j_4
      state.value_k_1 = value_jm.value_k_1
      state.value_k_2 = value_jm.value_k_2
      state.value_l_1 = value_jm.value_l_1
      state.value_l_2 = value_jm.value_l_2
      state.value_l_3 = value_jm.value_l_3
      state.value_m_1 = value_jm.value_m_1
      state.value_m_2 = value_jm.value_m_2
      state.value_m_3 = value_jm.value_m_3
    },
    async UPDATE_INFORMASI(state, info) {
      if (info) {
        console.log(
          '🚀 ~ file: kplhStore.js ~ line 213 ~ UPDATE_INFORMASI ~ info',
          info
        )
        state.vendor_name = await info.nama_vendor
        state.kplh_choosed_bu = await mixin.methods.$get(
          info,
          'badan_usaha.desc'
        )

        console.log(
          '🚀 ~ file: kplhStore.js ~ line 205 ~ UPDATE_INFORMASI ~ kplh_tanggal_berdiri',
          state.kplh_tanggal_berdiri
        )

        let storeKbli = []
        for (let i in info.kbli) {
          let newKbli = await info.kbli[i].kbli_sub
          newKbli['nib'] = await info.kbli[i].nib
          newKbli['ss_izin'] = await info.kbli[i].ss_izin
          newKbli['dokumen_lainnya'] = await info.kbli[i].dokumen_lainnya

          storeKbli.push(newKbli)
        }
        state.addedKbli = storeKbli

        state.vendor_address = await info.alamat
        state.choosed_country = await info.negara
        state.choosed_province = await info.provinsi
        state.choosed_city = await info.kota
        state.choosed_distric = await info.kecamatan
        state.choosed_village = await info.kelurahan
        // state.kodepos = await mixin.methods.$get(info, 'kelurahan.kodepos')
        if (info.negara_id == 63) {
          state.kodepos = await mixin.methods.$get(info, 'kelurahan.kodepos')
        } else {
          state.kodepos = await info.kode_pos_asing
        }

        state.pic_phone_code = await mixin.methods.$get(
          info,
          'negara.kode_telepon'
        )
      }
    },
    async UPDATE_LEGAL(state, legal) {
      if (legal) {
        for (let i in legal) {
          legal[i] = {
            ...legal[i],
            id: legal[i].legal_document_id,
          }
        }
        state.allLegal = legal
        let akta = await legal.filter(i => i.type == 1)
        let komersial = await legal.filter(
          i => i.type == 2 && i.legal_document_id != 7
        )
        let perizinan = await legal.filter(i => i.type == 3)

        let activeAkta = await akta.filter(i => i.lampiran)
        let newAkta = []
        for (let i in activeAkta) {
          let tmp = activeAkta[i]
          tmp['id'] = activeAkta[i].legal_document_id
          tmp['checked'] = true
          tmp['keterangan'] = activeAkta[i].no_dokumen
          tmp['start_date'] = mixin.methods.formatDateInput(
            activeAkta[i].tanggal_efektif
          )
          tmp['end_date'] = mixin.methods.formatDateInput(
            activeAkta[i].tanggal_berakhir
          )
          tmp['fileName'] = activeAkta[i].lampiran

          newAkta.push(tmp)
        }
        state.addedAktaPerusahaan = newAkta

        let activeKomersial = await komersial.filter(i => i.lampiran)
        let newKomersial = []
        for (let i in activeKomersial) {
          let tmp = activeKomersial[i]
          tmp['id'] = activeKomersial[i].legal_document_id
          tmp['checked'] = true
          tmp['keterangan'] = activeKomersial[i].no_dokumen
          tmp['start_date'] = mixin.methods.formatDateInput(
            activeKomersial[i].tanggal_efektif
          )
          tmp['end_date'] = mixin.methods.formatDateInput(
            activeKomersial[i].tanggal_berakhir
          )
          tmp['fileName'] = activeKomersial[i].lampiran

          newKomersial.push(tmp)
        }
        state.addedKomersial = newKomersial

        let activePerizinan = await perizinan.filter(i => i.lampiran)
        let newPerizinan = []
        for (let i in activePerizinan) {
          let tmp = activePerizinan[i]
          tmp['id'] = activePerizinan[i].legal_document_id
          tmp['checked'] = true
          tmp['is_lifetime'] =
            activePerizinan[i].tanggal_efektif == null &&
            activePerizinan[i].tanggal_berakhir == null
              ? true
              : false
          tmp['keterangan'] = activePerizinan[i].no_dokumen
          tmp['start_date'] = mixin.methods.formatDateInput(
            activePerizinan[i].tanggal_efektif
          )
          tmp['end_date'] = mixin.methods.formatDateInput(
            activePerizinan[i].tanggal_berakhir
          )
          tmp['fileName'] = activePerizinan[i].lampiran

          newPerizinan.push(tmp)
        }
        state.addedPerizinan = newPerizinan

        let getLogoFileName = legal.filter(i => i.legal_document_id == 44)
        state.logoFileName = getLogoFileName && getLogoFileName[0].lampiran

        let getPaktaFileName = legal.filter(i => i.legal_document_id == 31)
        state.paktaFileName = getPaktaFileName && getPaktaFileName[0].lampiran

        let getFormulirFileName = legal.filter(i => i.legal_document_id == 32)
        state.formulirFileName =
          getFormulirFileName && getFormulirFileName[0].lampiran

        let getSuratFileName = legal.filter(i => i.legal_document_id == 7)
        state.suratFileName = getSuratFileName && getSuratFileName[0].lampiran

        let getKomitmenKplhFileName = legal.filter(
          i => i.legal_document_id == 33
        )
        state.komitmenKplhFileName =
          getKomitmenKplhFileName && getKomitmenKplhFileName[0].lampiran

        let getKtpFileName = legal.filter(i => i.legal_document_id == 27)
        state.ktpFileName = getKtpFileName && getKtpFileName[0].lampiran

        let getNpwpFileName = legal.filter(i => i.legal_document_id == 5)
        state.npwpFileName = getNpwpFileName && getNpwpFileName[0].lampiran

        let getKkFileName = legal.filter(i => i.legal_document_id == 28)
        state.kkFileName = getKkFileName && getKkFileName[0].lampiran

        let getCoverFileName = legal.filter(i => i.legal_document_id == 34)
        state.coverFileName =
          getCoverFileName &&
          getCoverFileName.length > 0 &&
          getCoverFileName[0].lampiran

        let getRekomendasiFileName = legal.filter(
          i => i.legal_document_id == 29
        )
        state.rekomendasiFileName =
          getRekomendasiFileName && getRekomendasiFileName[0].lampiran

        state.adaRekomendasi =
          getRekomendasiFileName && getRekomendasiFileName[0].lampiran
            ? true
            : false

        let getRekeningFileName = legal.filter(i => i.legal_document_id == 30)
        state.rekeningFileName =
          getRekeningFileName && getRekeningFileName[0].lampiran
        state.adaRekening =
          getRekeningFileName && getRekeningFileName[0].lampiran ? true : false
      }
    },
    SET_ARRAY_DATA(state, data) {
      console.log('set object: ', data.name, data.operation, data.value)
      if (data.operation == 'add') {
        state.kbug_index = data.value.id
        state[data.name] = [...state[data.name], data.value]
      }

      if (data.operation == 'delete') {
        console.log('data delete: ', data.deleted)

        let filterData = state[data.name].filter(i => i.id !== data.value)
        state[data.name] = state[data.name].filter(i => i.id !== data.value)

        filterData.push(data.deleted)
        state[data.name] = filterData
      }

      if (data.operation == 'edit') {
        for (let i in state[data.name]) {
          console.log('operation: ', state[data.name])
          if (state[data.name][i].id == data.value.id) {
            state[data.name][i]['id'] = data.value.id
            state[data.name][i]['jenis_pekerjaan'] = data.value.jenis_pekerjaan
            state[data.name][i]['kbug_code'] = data.value.kbug_code
            state[data.name][i]['risk_value'] = data.value.risk_value
            state[data.name][i]['risk_param'] = data.value.risk_param
          }
        }
      }

      state.kbug_jenis_pekerjaan = ''
      state.kbug_kbug_code = ''
      state.kbug_risk_value = ''
      state.kbug_risk_param = ''
      state.kbug_edit = false
      state.kbug_add = false
    },
    SET_KPLH_DETAIL(state, data) {
      console.log('set kplh detail: ', data)
      // let regex = new RegExp(state.kplh_pic_phone_code)
      // if (state.is_vendor_done) {
      let isPhoneWithCode = false
      if (data && data.pic_phone_code) {
        state.pic_phone_code = data.pic_phone_code
        isPhoneWithCode = data.pic_phone.includes(data.pic_phone_code)
      }

      if (isPhoneWithCode) {
        state.pic_phone = data.pic_phone
      } else {
        state.pic_phone = `${state.pic_phone_code} ${data.pic_phone}`
      }

      state.pic_name = data.pic_name
      state.pic_position = data.pic_position
      state.pic_email = data.pic_email
      // }
      state.choosed_company = data.gems_company
      state.addedBidangUsahaGems = JSON.parse(data.bidang_usaha_gems)
    },
    CAL_KRITIS(state, data) {
      store.commit('kplhStore/CAL_TINGGI')

      let {
        
        bobot_a_1,
        bobot_a_2,
        bobot_b_1,
        bobot_b_2,
        bobot_b_3,
        bobot_b_4,
        bobot_c_1,
        bobot_c_2,
        bobot_d_1,
        bobot_d_2,
        bobot_e_1,
        bobot_e_2,
        bobot_e_3,
        bobot_f_1,
        bobot_f_2,
        bobot_f_3,
        bobot_f_4,
        bobot_g_1,
        bobot_g_2,
        bobot_g_3,
        bobot_h_1,
        bobot_i1_1,
        bobot_i1_2,
        bobot_i2_1,
        bobot_i2_2,
        bobot_i2_3,
        bobot_i2_4,
        bobot_i31_1,
        bobot_i31_2,
        bobot_i31_3,
        bobot_i31_4,
        bobot_i32_1,
        bobot_i33_1,
        bobot_i33_2,
        bobot_i34_1,
        bobot_i34_2,
        bobot_i34_3,
        bobot_i4_1,
        bobot_i4_2,
        bobot_i4_3,
        bobot_i51_1,
        bobot_i51_2,
        bobot_i52_1,
        bobot_i52_2,
        bobot_i52_3,
        bobot_i53_1,
        bobot_i53_2,
        bobot_i54_1,
        bobot_i54_2,
        bobot_i54_3,
        bobot_i6_1,
        bobot_i6_2,
        bobot_i7_1,
        bobot_i7_2,
        bobot_i8_1,
        bobot_i8_2,
        bobot_i8_3,
        bobot_i9_1,
        bobot_i9_2,
        bobot_j_1,
        bobot_j_2,
        bobot_j_3,
        bobot_j_4,
        bobot_k_1,
        bobot_k_2,
        bobot_l_1,
        bobot_l_2,
        bobot_l_3,
        bobot_m_1,
        bobot_m_2,
        bobot_m_3,

        value_a_1,
        value_a_2,
        value_b_1,
        value_b_2,
        value_b_3,
        value_b_4,
        value_c_1,
        value_c_2,
        value_d_1,
        value_d_2,
        value_e_1,
        value_e_2,
        value_e_3,
        value_f_1,
        value_f_2,
        value_f_3,
        value_f_4,
        value_g_1,
        value_g_2,
        value_g_3,
        value_h_1,
        value_i1_1,
        value_i1_2,
        value_i2_1,
        value_i2_2,
        value_i2_3,
        value_i2_4,
        value_i31_1,
        value_i31_2,
        value_i31_3,
        value_i31_4,
        value_i32_1,
        value_i33_1,
        value_i33_2,
        value_i34_1,
        value_i34_2,
        value_i34_3,
        value_i4_1,
        value_i4_2,
        value_i4_3,
        value_i51_1,
        value_i51_2,
        value_i52_1,
        value_i52_2,
        value_i52_3,
        value_i53_1,
        value_i53_2,
        value_i54_1,
        value_i54_2,
        value_i54_3,
        value_i6_1,
        value_i6_2,
        value_i7_1,
        value_i7_2,
        value_i8_1,
        value_i8_2,
        value_i8_3,
        value_i9_1,
        value_i9_2,
        value_j_1,
        value_j_2,
        value_j_3,
        value_j_4,
        value_k_1,
        value_k_2,
        value_l_1,
        value_l_2,
        value_l_3,
        value_m_1,
        value_m_2,
        value_m_3,
      } = state
      
      let nilai_a = 0;
      let pertanyaan_a = 2;
        value_a_1 =
            value_a_1 == 'N/A'
            ? (bobot_a_1 = 0, pertanyaan_a--)
            : value_a_1 == ''
            ? 0
            : (nilai_a += Number(value_a_1))          
        value_a_2 =
            value_a_2 == 'N/A'
            ? (bobot_a_2 = 0, pertanyaan_a--)
            : value_a_2 == ''
            ? 0
            : (nilai_a += Number(value_a_2))

        let bobot_a = bobot_a_1 + bobot_a_2;
        pertanyaan_a == 0 ? (pertanyaan_a = 1) : pertanyaan_a;    
        nilai_a = (((Number(nilai_a) * bobot_a) / 3) / pertanyaan_a).toFixed(2);
        nilai_a = Number(nilai_a);
        console.log('nilai a', nilai_a, value_a_1, value_a_2);
      
      let nilai_b = 0;
      let pertanyaan_b = 4;
        value_b_1 =
            value_b_1 == 'N/A'
            ? (bobot_b_1 = 0, pertanyaan_b--)
            : value_b_1 == ''
            ? 0
            : (nilai_b += Number(value_b_1))          
        value_b_2 =
            value_b_2 == 'N/A'
            ? (bobot_b_2 = 0, pertanyaan_b--)
            : value_b_2 == ''
            ? 0
            : (nilai_b += Number(value_b_2))
        value_b_3 =
            value_b_3 == 'N/A'
            ? (bobot_b_3 = 0, pertanyaan_b--)
            : value_b_3 == ''
            ? 0
            : (nilai_b += Number(value_b_3))
        value_b_4 =
            value_b_4 == 'N/A'
            ? (bobot_b_4 = 0, pertanyaan_b--)
            : value_b_4 == ''
            ? 0
            : (nilai_b += Number(value_b_4))
        let bobot_b = bobot_b_1 + bobot_b_2 + bobot_b_3 + bobot_b_4;
        pertanyaan_b == 0 ? (pertanyaan_b = 1) : pertanyaan_b;    
        nilai_b = (((Number(nilai_b) * bobot_b) / 3) / pertanyaan_b).toFixed(2);
        nilai_b = Number(nilai_b);
        console.log('nilai b', nilai_b, value_b_1, value_b_2, value_b_3, value_b_4);
        
      
      let nilai_c = 0;
      let pertanyaan_c = 2;
        value_c_1 =
            value_c_1 == 'N/A'
            ? (bobot_c_1 = 0, pertanyaan_c--)
            : value_c_1 == ''
            ? 0
            : (nilai_c += Number(value_c_1))          
        value_c_2 =
            value_c_2 == 'N/A'
            ? (bobot_c_2 = 0, pertanyaan_c--)
            : value_c_2 == ''
            ? 0
            : (nilai_c += Number(value_c_2))
    
        let bobot_c = bobot_c_1 + bobot_c_2;
        pertanyaan_c == 0 ? (pertanyaan_c = 1) : pertanyaan_c;    
        nilai_c = (((Number(nilai_c) * bobot_c) / 3) / pertanyaan_c).toFixed(2);
        nilai_c = Number(nilai_c);
        console.log('value c', nilai_c, value_c_1, value_c_2);

      let nilai_d = 0;
      let pertanyaan_d = 2;
        value_d_1 =
            value_d_1 == 'N/A'
            ? (bobot_d_1 = 0, pertanyaan_d--)
            : value_d_1 == ''
            ? 0
            : (nilai_d += Number(value_d_1))          
        value_d_2 =
            value_d_2 == 'N/A'
            ? (bobot_d_2 = 0, pertanyaan_d--)
            : value_d_2 == ''
            ? 0
            : (nilai_d += Number(value_d_2))
    
        let bobot_d = bobot_d_1 + bobot_d_2;
        pertanyaan_d == 0 ? (pertanyaan_d = 1) : pertanyaan_d;    
        nilai_d = (((Number(nilai_d) * bobot_d) / 3) / pertanyaan_d).toFixed(2);
        nilai_d = Number(nilai_d);
        console.log('value d', nilai_d, value_d_1, value_d_2);

      let nilai_e = 0;
      let pertanyaan_e = 3;        
        value_e_1 =
            value_e_1 == 'N/A'
            ? (bobot_e_1 = 0, pertanyaan_e--)
            : value_e_1 == ''
            ? 0
            : (nilai_e += Number(value_e_1))          
        value_e_2 =
            value_e_2 == 'N/A'
            ? (bobot_e_2 = 0, pertanyaan_e--)
            : value_e_2 == ''
            ? 0
            : (nilai_e += Number(value_e_2))
        value_e_3 =
            value_e_3 == 'N/A'
            ? (bobot_e_3 = 0, pertanyaan_e--)
            : value_e_3 == ''
            ? 0
            : (nilai_e += Number(value_e_3))

        let bobot_e = bobot_e_1 + bobot_e_2 + bobot_e_3;
        pertanyaan_e == 0 ? (pertanyaan_e = 1) : pertanyaan_e;    
        nilai_e = (((Number(nilai_e) * bobot_e) / 3) / pertanyaan_e).toFixed(2);
        nilai_e = Number(nilai_e);
        console.log('e', nilai_e, value_e_1 ,value_e_2, value_e_3);

      let nilai_f = 0;
      let pertanyaan_f = 4;        
        value_f_1 =
            value_f_1 == 'N/A'
            ? (bobot_f_1 = 0, pertanyaan_f--)
            : value_f_1 == ''
            ? 0
            : (nilai_f += Number(value_f_1))          
        value_f_2 =
            value_f_2 == 'N/A'
            ? (bobot_f_2 = 0, pertanyaan_f--)
            : value_f_2 == ''
            ? 0
            : (nilai_f += Number(value_f_2))
        value_f_3 =
            value_f_3 == 'N/A'
            ? (bobot_f_3 = 0, pertanyaan_f--)
            : value_f_3 == ''
            ? 0
            : (nilai_f += Number(value_f_3))
        value_f_4 =
            value_f_4 == 'N/A'
            ? (bobot_f_4 = 0, pertanyaan_f--)
            : value_f_4 == ''
            ? 0
            : (nilai_f += Number(value_f_4))
      
          let bobot_f = bobot_f_1 + bobot_f_2 + bobot_f_3 + bobot_f_4;
          pertanyaan_f == 0 ? (pertanyaan_f = 1) : pertanyaan_f;    
          nilai_f = (((Number(nilai_f) * bobot_f) / 3) / pertanyaan_f).toFixed(2);
          nilai_f = Number(nilai_f);
          console.log('f', nilai_f, value_f_1 ,value_f_2, value_f_3, value_f_4);

      let nilai_g = 0;
      let pertanyaan_g = 3;        
        value_g_1 =
            value_g_1 == 'N/A'
            ? (bobot_g_1 = 0, pertanyaan_g--)
            : value_g_1 == ''
            ? 0
            : (nilai_g += Number(value_g_1))          
        value_g_2 =
            value_g_2 == 'N/A'
            ? (bobot_g_2 = 0, pertanyaan_g--)
            : value_g_2 == ''
            ? 0
            : (nilai_g += Number(value_g_2))
        value_g_3 =
            value_g_3 == 'N/A'
            ? (bobot_g_3 = 0, pertanyaan_g--)
            : value_g_3 == ''
            ? 0
            : (nilai_g += Number(value_g_3))

          let bobot_g = bobot_g_1 + bobot_g_2 + bobot_g_3;
          pertanyaan_g == 0 ? (pertanyaan_g = 1) : pertanyaan_g;    
          nilai_g = (((Number(nilai_g) * bobot_g) / 3) / pertanyaan_g).toFixed(2);
          nilai_g = Number(nilai_g);
          console.log('g', nilai_g, value_g_1 ,value_g_2, value_g_3);

        let nilai_h = 0
        value_h_1 =
        value_h_1 == 'N/A'
          ? (bobot_h_1 = 0)
          : value_h_1 == ''
          ? 0
          : nilai_h = Number((((value_h_1 * bobot_h_1)/3)/1).toFixed(2));
          console.log('h', nilai_h, value_h_1);
        
        let nilai_i1 = 0;
        let pertanyaan_i1 = 2;
          value_i1_1 =
              value_i1_1 == 'N/A'
              ? (bobot_i1_1 = 0, pertanyaan_i1--)
              : value_i1_1 == ''
              ? 0
              : (nilai_i1 += Number(value_i1_1))          
          value_i1_2 =
              value_i1_2 == 'N/A'
              ? (bobot_i1_2 = 0, pertanyaan_i1--)
              : value_i1_2 == ''
              ? 0
              : (nilai_i1 += Number(value_i1_2))
              
            let bobot_i1 = bobot_i1_1 + bobot_i1_2;
            pertanyaan_i1 == 0 ? (pertanyaan_i1 = 1) : pertanyaan_i1;    
            nilai_i1 = (((Number(nilai_i1) * bobot_i1) / 3) / pertanyaan_i1).toFixed(2);
            nilai_i1 = Number(nilai_i1);
            console.log('i1', nilai_i1, value_i1_1, value_i1_2);

        let nilai_i2 = 0;
        let pertanyaan_i2 = 4;
          value_i2_1 =
              value_i2_1 == 'N/A'
              ? (bobot_i2_1 = 0, pertanyaan_i2--)
              : value_i2_1 == ''
              ? 0
              : (nilai_i2 += Number(value_i2_1))          
          value_i2_2 =
              value_i2_2 == 'N/A'
              ? (bobot_i2_2 = 0, pertanyaan_i2--)
              : value_i2_2 == ''
              ? 0
              : (nilai_i2 += Number(value_i2_2))
          value_i2_3 =
              value_i2_3 == 'N/A'
              ? (bobot_i2_3 = 0, pertanyaan_i2--)
              : value_i2_3 == ''
              ? 0
              : (nilai_i2 += Number(value_i2_3))
          value_i2_4 =
              value_i2_4 == 'N/A'
              ? (bobot_i2_4 = 0, pertanyaan_i2--)
              : value_i2_4 == ''
              ? 0
              : (nilai_i2 += Number(value_i2_4))
              
            let bobot_i2 = bobot_i2_1 + bobot_i2_2 + bobot_i2_3 + bobot_i2_4;
            pertanyaan_i2 == 0 ? (pertanyaan_i2 = 1) : pertanyaan_i2;    
            nilai_i2 = (((Number(nilai_i2) * bobot_i2) / 3) / pertanyaan_i2).toFixed(2);
            nilai_i2 = Number(nilai_i2);
            console.log('i2', nilai_i2, value_i2_1, value_i2_2, value_i2_3, value_i2_4);

        let nilai_i31 = 0;
        let pertanyaan_i31 = 4;        
          value_i31_1 =
              value_i31_1 == 'N/A'
              ? (bobot_i31_1 = 0, pertanyaan_i31--)
              : value_i31_1 == ''
              ? 0
              : (nilai_i31 += Number(value_i31_1))          
          value_i31_2 =
              value_i31_2 == 'N/A'
              ? (bobot_i31_2 = 0, pertanyaan_i31--)
              : value_i31_2 == ''
              ? 0
              : (nilai_i31 += Number(value_i31_2))
          value_i31_3 =
              value_i31_3 == 'N/A'
              ? (bobot_i31_3 = 0, pertanyaan_i31--)
              : value_i31_3 == ''
              ? 0
              : (nilai_i31 += Number(value_i31_3))          
          value_i31_4 =
              value_i31_4 == 'N/A'
              ? (bobot_i31_4 = 0, pertanyaan_i31--)
              : value_i31_4 == ''
              ? 0
              : (nilai_i31 += Number(value_i31_4))
            
            let bobot_i31 = bobot_i31_1 + bobot_i31_2 + bobot_i31_3 + bobot_i31_4;
            pertanyaan_i31 == 0 ? (pertanyaan_i31 = 1) : pertanyaan_i31;    
            nilai_i31 = (((Number(nilai_i31) * bobot_i31) / 3) / pertanyaan_i31).toFixed(2);
            nilai_i31 = Number(nilai_i31);
            console.log('i31', nilai_i31, value_i31_1, value_i31_2, value_i31_3, value_i31_4);

      let nilai_i32_1 = 0
      value_i32_1 =
        value_i32_1 == 'N/A'
          ? (bobot_i32_1 = 0)
          : value_i32_1 == ''
          ? 0
          : nilai_i32_1 = Number((((value_i32_1 * bobot_i32_1)/3)/1).toFixed(2));
          console.log('i32_1', nilai_i32_1, value_i32_1);

      let nilai_i33 = 0;
      let pertanyaan_i33 = 2;          
        value_i33_1 =
            value_i33_1 == 'N/A'
            ? (bobot_i33_1 = 0, pertanyaan_i33--)
            : value_i33_1 == ''
            ? 0
            : (nilai_i33 += Number(value_i33_1))          
        value_i33_2 =
            value_i33_2 == 'N/A'
            ? (bobot_i33_2 = 0, pertanyaan_i33--)
            : value_i33_2 == ''
            ? 0
            : (nilai_i33 += Number(value_i33_2))
          
          let bobot_i33 = bobot_i33_1 + bobot_i33_2;
          pertanyaan_i33 == 0 ? (pertanyaan_i33 = 1) : pertanyaan_i33;    
          nilai_i33 = (((Number(nilai_i33) * bobot_i33) / 3) / pertanyaan_i33).toFixed(2);
          nilai_i33 = Number(nilai_i33);
          console.log('i33', nilai_i33, value_i33_1, value_i33_2);

      let nilai_i34 = 0;
      let pertanyaan_i34 = 3;          
        value_i34_1 =
            value_i34_1 == 'N/A'
            ? (bobot_i34_1 = 0, pertanyaan_i34--)
            : value_i34_1 == ''
            ? 0
            : (nilai_i34 += Number(value_i34_1))          
        value_i34_2 =
            value_i34_2 == 'N/A'
            ? (bobot_i34_2 = 0, pertanyaan_i34--)
            : value_i34_2 == ''
            ? 0
            : (nilai_i34 += Number(value_i34_2))
        value_i34_3 =
            value_i34_3 == 'N/A'
            ? (bobot_i34_3 = 0, pertanyaan_i34--)
            : value_i34_3 == ''
            ? 0
            : (nilai_i34 += Number(value_i34_3))
          
          let bobot_i34 = bobot_i34_1 + bobot_i34_2 + bobot_i34_3;
          pertanyaan_i34 == 0 ? (pertanyaan_i34 = 1) : pertanyaan_i34;    
          nilai_i34 = (((Number(nilai_i34) * bobot_i34) / 3) / pertanyaan_i34).toFixed(2);
          nilai_i34 = Number(nilai_i34);
          console.log('i34', nilai_i34, value_i34_1, value_i34_2);

      let nilai_i4 = 0;
      let pertanyaan_i4 = 3;                 
        value_i4_1 =
            value_i4_1 == 'N/A'
            ? (bobot_i4_1 = 0, pertanyaan_i4--)
            : value_i4_1 == ''
            ? 0
            : (nilai_i4 += Number(value_i4_1))          
        value_i4_2 =
            value_i4_2 == 'N/A'
            ? (bobot_i4_2 = 0, pertanyaan_i4--)
            : value_i4_2 == ''
            ? 0
            : (nilai_i4 += Number(value_i4_2))          
        value_i4_3 =
            value_i4_3 == 'N/A'
            ? (bobot_i4_3 = 0, pertanyaan_i4--)
            : value_i4_3 == ''
            ? 0
            : (nilai_i4 += Number(value_i4_3))
          let bobot_i4 = bobot_i4_1 + bobot_i4_2 + bobot_i4_3;
          console.log('nilai i4', nilai_i4, 'bobot: ', bobot_i4);
          pertanyaan_i4 == 0 ? (pertanyaan_i4 = 1) : pertanyaan_i4;    
          nilai_i4 = (((nilai_i4 * bobot_i4) / 3) / pertanyaan_i4).toFixed(2);
          nilai_i4 = Number(nilai_i4);
          console.log('i4', nilai_i4, value_i4_1, value_i4_2, value_i4_3);

      let nilai_i51 = 0;
      let pertanyaan_i51 = 2;
        value_i51_1 =
            value_i51_1 == 'N/A'
            ? (bobot_i51_1 = 0, pertanyaan_i51--)
            : value_i51_1 == ''
            ? 0
            : (nilai_i51 += Number(value_i51_1))          
        value_i51_2 =
            value_i51_2 == 'N/A'
            ? (bobot_i51_2 = 0, pertanyaan_i51--)
            : value_i51_2 == ''
            ? 0
            : (nilai_i51 += Number(value_i51_2))          
          
          let bobot_i51 = bobot_i51_1 + bobot_i51_2;
          pertanyaan_i51 == 0 ? (pertanyaan_i51 = 1) : pertanyaan_i51;    
          nilai_i51 = (((Number(nilai_i51) * bobot_i51) / 3) / pertanyaan_i51).toFixed(2);
          nilai_i51 = Number(nilai_i51);
          console.log('i51', nilai_i51, value_i51_1, value_i51_2);

      let nilai_i52 = 0;
      let pertanyaan_i52 = 3;        
        value_i52_1 =
            value_i52_1 == 'N/A'
            ? (bobot_i52_1 = 0, pertanyaan_i52--)
            : value_i52_1 == ''
            ? 0
            : (nilai_i52 += Number(value_i52_1))          
        value_i52_2 =
            value_i52_2 == 'N/A'
            ? (bobot_i52_2 = 0, pertanyaan_i52--)
            : value_i52_2 == ''
            ? 0
            : (nilai_i52 += Number(value_i52_2))          
        value_i52_3 =
            value_i52_3 == 'N/A'
            ? (bobot_i52_3 = 0, pertanyaan_i52--)
            : value_i52_3 == ''
            ? 0
            : (nilai_i52 += Number(value_i52_3))          
          
          let bobot_i52 = bobot_i52_1 + bobot_i52_2 + bobot_i52_3;
          pertanyaan_i52 == 0 ? (pertanyaan_i52 = 1) : pertanyaan_i52;    
          nilai_i52 = (((Number(nilai_i52) * bobot_i52) / 3) / pertanyaan_i52).toFixed(2);
          nilai_i52 = Number(nilai_i52);
          console.log('i52', nilai_i52, value_i52_1, value_i52_2, value_i52_3);

      let nilai_i53 = 0;
      let pertanyaan_i53 = 2;        
        value_i53_1 =
            value_i53_1 == 'N/A'
            ? (bobot_i53_1 = 0, pertanyaan_i53--)
            : value_i53_1 == ''
            ? 0
            : (nilai_i53 += Number(value_i53_1))          
        value_i53_2 =
            value_i53_2 == 'N/A'
            ? (bobot_i53_2 = 0, pertanyaan_i53--)
            : value_i53_2 == ''
            ? 0
            : (nilai_i53 += Number(value_i53_2))        
          
          let bobot_i53 = bobot_i53_1 + bobot_i53_2;
          pertanyaan_i53 == 0 ? (pertanyaan_i53 = 1) : pertanyaan_i53;    
          nilai_i53 = (((Number(nilai_i53) * bobot_i53) / 3) / pertanyaan_i53).toFixed(2);
          nilai_i53 = Number(nilai_i53);
          console.log('i53', nilai_i53, value_i53_1, value_i53_2);

      let nilai_i54 = 0;
      let pertanyaan_i54 = 3;
        value_i54_1 =
            value_i54_1 == 'N/A'
            ? (bobot_i54_1 = 0, pertanyaan_i54--)
            : value_i54_1 == ''
            ? 0
            : (nilai_i54 += Number(value_i54_1))        
        value_i54_2 =
            value_i54_2 == 'N/A'
            ? (bobot_i54_2 = 0, pertanyaan_i54--)
            : value_i54_2 == ''
            ? 0
            : (nilai_i54 += Number(value_i54_2))          
        value_i54_3 =
            value_i54_3 == 'N/A'
            ? (bobot_i54_3 = 0, pertanyaan_i54--)
            : value_i54_3 == ''
            ? 0
            : (nilai_i54 += Number(value_i54_3))          
          
          let bobot_i54 = bobot_i54_1 + bobot_i54_2 + bobot_i54_3;
          pertanyaan_i54 == 0 ? (pertanyaan_i54 = 1) : pertanyaan_i54;    
          nilai_i54 = (((Number(nilai_i54) * bobot_i54) / 3) / pertanyaan_i54).toFixed(2);
          nilai_i54 = Number(nilai_i54);
          console.log('i54', nilai_i54, value_i54_1, value_i54_2, value_i54_3);

      let nilai_i6 = 0;
      let pertanyaan_i6 = 2;
        value_i6_1 =
            value_i6_1 == 'N/A'
            ? (bobot_i6_1 = 0, pertanyaan_i6--)
            : value_i6_1 == ''
            ? 0
            : (nilai_i6 += Number(value_i6_1))        
        value_i6_2 =
            value_i6_2 == 'N/A'
            ? (bobot_i6_2 = 0, pertanyaan_i6--)
            : value_i6_2 == ''
            ? 0
            : (nilai_i6 += Number(value_i6_2))          
          
          let bobot_i6 = bobot_i6_1 + bobot_i6_2;
          pertanyaan_i6 == 0 ? (pertanyaan_i6 = 1) : pertanyaan_i6;    
          nilai_i6 = (((Number(nilai_i6) * bobot_i6) / 3) / pertanyaan_i6).toFixed(2);
          nilai_i6 = Number(nilai_i6);
          console.log('i6', nilai_i6, value_i6_1, value_i6_2);

      let nilai_i7 = 0;
      let pertanyaan_i7 = 2;        
      value_i7_1 =
      value_i7_1 == 'N/A'
      ? (bobot_i7_1 = 0, pertanyaan_i7--)
      : value_i7_1 == ''
      ? 0
      : (nilai_i7 += Number(value_i7_1))        
        value_i7_2 =
        value_i7_2 == 'N/A'
        ? (bobot_i7_2 = 0, pertanyaan_i7--)
        : value_i7_2 == ''
        ? 0
        : (nilai_i7 += Number(value_i7_2))          
        
          let bobot_i7 = bobot_i7_1 + bobot_i7_2; 
          pertanyaan_i7 == 0 ? (pertanyaan_i7 = 1) : pertanyaan_i7;    
          nilai_i7 = (((Number(nilai_i7) * bobot_i7) / 3) / pertanyaan_i7).toFixed(2);
          nilai_i7 = Number(nilai_i7);
          console.log('i7', nilai_i7, value_i7_1, value_i7_2);

      let nilai_i8 = 0;
      let pertanyaan_i8 = 3;        
        value_i8_1 =
            value_i8_1 == 'N/A'
            ? (bobot_i8_1 = 0, pertanyaan_i8--)
            : value_i8_1 == ''
            ? 0
            : (nilai_i8 += Number(value_i8_1))        
        value_i8_2 =
            value_i8_2 == 'N/A'
            ? (bobot_i8_2 = 0, pertanyaan_i8--)
            : value_i8_2 == ''
            ? 0
            : (nilai_i8 += Number(value_i8_2))
        value_i8_3 =
            value_i8_3 == 'N/A'
            ? (bobot_i8_3 = 0, pertanyaan_i8--)
            : value_i8_3 == ''
            ? 0
            : (nilai_i8 += Number(value_i8_3))
            
          let bobot_i8 = bobot_i8_1 + bobot_i8_2 + bobot_i8_3;
          console.log('value i8', value_i8_1);
          pertanyaan_i8 == 0 ? (pertanyaan_i8 = 1) : pertanyaan_i8;    
          nilai_i8 = (((Number(nilai_i8) * bobot_i8) / 3) / pertanyaan_i8).toFixed(2);
          nilai_i8 = Number(nilai_i8);
          console.log('i8', nilai_i8, value_i8_1, value_i8_2, value_i8_3);

      let nilai_i9 = 0;
      let pertanyaan_i9 = 2;        
        value_i9_1 =
            value_i9_1 == 'N/A'
            ? (bobot_i9_1 = 0, pertanyaan_i9--)
            : value_i9_1 == ''
            ? 0
            : (nilai_i9 += Number(value_i9_1))        
        value_i9_2 =
            value_i9_2 == 'N/A'
            ? (bobot_i9_2 = 0, pertanyaan_i9--)
            : value_i9_2 == ''
            ? 0
            : (nilai_i9 += Number(value_i9_2))          

          let bobot_i9 = bobot_i9_1 + bobot_i9_2;
          pertanyaan_i9 == 0 ? (pertanyaan_i9 = 1) : pertanyaan_i9;    
          nilai_i9 = (((Number(nilai_i9) * bobot_i9) / 3) / pertanyaan_i9).toFixed(2);
          nilai_i9 = Number(nilai_i9);
          console.log('i9', nilai_i9, value_i9_1, value_i9_2);

      let nilai_j = 0;
      let pertanyaan_j = 4;        
        value_j_1 =
            value_j_1 == 'N/A'
            ? (bobot_j_1 = 0, pertanyaan_j--)
            : value_j_1 == ''
            ? 0
            : (nilai_j += Number(value_j_1))        
        value_j_2 =
            value_j_2 == 'N/A'
            ? (bobot_j_2 = 0, pertanyaan_j--)
            : value_j_2 == ''
            ? 0
            : (nilai_j += Number(value_j_2))
        value_j_3 =
            value_j_3 == 'N/A'
            ? (bobot_j_3 = 0, pertanyaan_j--)
            : value_j_3 == ''
            ? 0
            : (nilai_j += Number(value_j_3))
        value_j_4 =
            value_j_4 == 'N/A'
            ? (bobot_j_4 = 0, pertanyaan_j--)
            : value_j_4 == ''
            ? 0
            : (nilai_j += Number(value_j_4))
          
          let bobot_j = bobot_j_1 + bobot_j_2 + bobot_j_3 + bobot_j_4;
          pertanyaan_j == 0 ? (pertanyaan_j = 1) : pertanyaan_j;    
          nilai_j = (((Number(nilai_j) * bobot_j) / 3) / pertanyaan_j).toFixed(2);
          nilai_j = Number(nilai_j);
          console.log('j', nilai_j, value_j_1, value_j_2, value_j_3, value_j_4);

      let nilai_k = 0;
      let pertanyaan_k = 2;
        value_k_1 =
            value_k_1 == 'N/A'
            ? (bobot_k_1 = 0, pertanyaan_k--)
            : value_k_1 == ''
            ? 0
            : (nilai_k += Number(value_k_1))        
        value_k_2 =
            value_k_2 == 'N/A'
            ? (bobot_k_2 = 0, pertanyaan_k--)
            : value_k_2 == ''
            ? 0
            : (nilai_k += Number(value_k_2))
          
          let bobot_k = bobot_k_1 + bobot_k_2;
          pertanyaan_k == 0 ? (pertanyaan_k = 1) : pertanyaan_k;    
          nilai_k = (((Number(nilai_k) * bobot_k) / 3) / pertanyaan_k).toFixed(2);
          nilai_k = Number(nilai_k);
          console.log('k', nilai_k, value_k_1, value_k_2);

      let nilai_l = 0;
      let pertanyaan_l = 3;
        value_l_1 =
            value_l_1 == 'N/A'
            ? (bobot_l_1 = 0, pertanyaan_l--)
            : value_l_1 == ''
            ? 0
            : (nilai_l += Number(value_l_1))        
        value_l_2 =
            value_l_2 == 'N/A'
            ? (bobot_l_2 = 0, pertanyaan_l--)
            : value_l_2 == ''
            ? 0
            : (nilai_l += Number(value_l_2))
        value_l_3 =
            value_l_3 == 'N/A'
            ? (bobot_l_3 = 0, pertanyaan_l--)
            : value_l_3 == ''
            ? 0
            : (nilai_l += Number(value_l_3))
          
          let bobot_l = bobot_l_1 + bobot_l_2 + bobot_l_3;
          pertanyaan_l == 0 ? (pertanyaan_l = 1) : pertanyaan_l;    
          nilai_l = (((Number(nilai_l) * bobot_l) / 3) / pertanyaan_l).toFixed(2);
          nilai_l = Number(nilai_l);
          console.log('l', nilai_l, value_l_1, value_l_2, value_l_3);

      let nilai_m = 0;
      let pertanyaan_m = 3;
        value_m_1 =
            value_m_1 == 'N/A'
            ? (bobot_m_1 = 0, pertanyaan_m--)
            : value_m_1 == ''
            ? 0
            : (nilai_m += Number(value_m_1))        
        value_m_2 =
            value_m_2 == 'N/A'
            ? (bobot_m_2 = 0, pertanyaan_m--)
            : value_m_2 == ''
            ? 0
            : (nilai_m += Number(value_m_2))
        value_m_3 =
            value_m_3 == 'N/A'
            ? (bobot_m_3 = 0, pertanyaan_m--)
            : value_m_3 == ''
            ? 0
            : (nilai_m += Number(value_m_3))
          
          let bobot_m = bobot_m_1 + bobot_m_2 + bobot_m_3;
          pertanyaan_m == 0 ? (pertanyaan_m = 1) : pertanyaan_m;    
          nilai_m = (((Number(nilai_m) * bobot_m) / 3) / pertanyaan_m).toFixed(2);
          nilai_m = Number(nilai_m);
          console.log('m', nilai_m, value_m_1, value_m_2, value_m_3);

        state.bobot_kritis =
          bobot_c_2 +
          bobot_f_4 +
          bobot_i1_1 +
          bobot_i1_2 +
          bobot_i2_4 +
          bobot_i31_3 +
          bobot_i31_4 +
          bobot_i33_1 +
          bobot_i33_2 +
          bobot_i34_2 +
          bobot_i53_1 +
          bobot_i53_2 +
          bobot_i54_2 +
          bobot_l_1 +
          bobot_l_2 +
          bobot_l_3 +
          bobot_m_1 +
          bobot_m_2 +
          bobot_m_3 +
          state.bobot_tinggi

      state.total_kritis =
        (nilai_a +
        nilai_b +
        nilai_c +
        nilai_d +
        nilai_e +
        nilai_f +
        nilai_g +
        nilai_h +
        nilai_i1 +
        nilai_i2 +
        nilai_i31 +
        nilai_i32_1 +
        nilai_i33 +
        nilai_i34 +
        nilai_i4 +
        nilai_i51 +
        nilai_i52 +
        nilai_i53 +
        nilai_i54 +
        nilai_i6 +
        nilai_i7 +
        nilai_i8 +
        nilai_i9 +
        nilai_j +
        nilai_k +
        nilai_l +
        nilai_m).toFixed(2)
        // state.total_sedang


      state.bobot_kritis =
        bobot_c_2 +
        bobot_f_4 +
        bobot_i1_1 +
        bobot_i1_2 +
        bobot_i2_4 +
        bobot_i31_3 +
        bobot_i31_4 +
        bobot_i33_1 +
        bobot_i33_2 +
        bobot_i34_2 +
        bobot_i53_1 +
        bobot_i53_2 +
        bobot_i54_2 +
        bobot_l_1 +
        bobot_l_2 +
        bobot_l_3 +
        bobot_m_1 +
        bobot_m_2 +
        bobot_m_3 +
        state.bobot_tinggi
    },
    CAL_TINGGI(state, data) {
      store.commit('kplhStore/CAL_SEDANG')

      let {
        bobot_a_1,
        bobot_a_2,
        bobot_b_1,
        bobot_b_2,
        bobot_b_3,
        bobot_b_4,
        bobot_c_1,
        bobot_d_1,
        bobot_d_2,
        bobot_e_1,
        bobot_e_2,
        bobot_e_3,
        bobot_f_1,
        bobot_f_2,
        bobot_f_3,
        bobot_g_1,
        bobot_g_2,
        bobot_g_3,
        bobot_h_1,
        bobot_i2_1,
        bobot_i2_2,
        bobot_i2_3,
        bobot_i31_1,
        bobot_i31_2,
        bobot_i32_1,
        bobot_i34_1,
        bobot_i34_3,
        bobot_i4_1,
        bobot_i4_2,
        bobot_i4_3,
        bobot_i51_1,
        bobot_i51_2,
        bobot_i52_1,
        bobot_i52_2,
        bobot_i52_3,
        bobot_i54_1,
        bobot_i54_3,
        bobot_i6_1,
        bobot_i6_2,
        bobot_i7_1,
        bobot_i7_2,
        bobot_i8_1,
        bobot_i8_2,
        bobot_i8_3,
        bobot_i9_1,
        bobot_i9_2,
        bobot_j_1,
        bobot_j_2,
        bobot_j_3,
        bobot_j_4,
        bobot_k_1,
        bobot_k_2,

        value_a_1,
        value_a_2,
        value_b_1,
        value_b_2,
        value_b_3,
        value_b_4,
        value_c_1,
        value_d_1,
        value_d_2,
        value_e_1,
        value_e_2,
        value_e_3,
        value_f_1,
        value_f_2,
        value_f_3,
        value_g_1,
        value_g_2,
        value_g_3,
        value_h_1,
        value_i2_1,
        value_i2_2,
        value_i2_3,
        value_i31_1,
        value_i31_2,
        value_i32_1,
        value_i34_1,
        value_i34_3,
        value_i4_1,
        value_i4_2,
        value_i4_3,
        value_i51_1,
        value_i51_2,
        value_i52_1,
        value_i52_2,
        value_i52_3,
        value_i54_1,
        value_i54_3,
        value_i6_1,
        value_i6_2,
        value_i7_1,
        value_i7_2,
        value_i8_1,
        value_i8_2,
        value_i8_3,
        value_i9_1,
        value_i9_2,
        value_j_1,
        value_j_2,
        value_j_3,
        value_j_4,
        value_k_1,
        value_k_2,
      } = state
      
      let nilai_a = 0;
      let pertanyaan_a = 2;
        value_a_1 =
            value_a_1 == 'N/A'
            ? (bobot_a_1 = 0, pertanyaan_a--)
            : value_a_1 == ''
            ? 0
            : (nilai_a += Number(value_a_1))          
        value_a_2 =
            value_a_2 == 'N/A'
            ? (bobot_a_2 = 0, pertanyaan_a--)
            : value_a_2 == ''
            ? 0
            : (nilai_a += Number(value_a_2))

        let bobot_a = bobot_a_1 + bobot_a_2;
        pertanyaan_a == 0 ? (pertanyaan_a = 1) : pertanyaan_a;    
        nilai_a = (((Number(nilai_a) * bobot_a) / 3) / pertanyaan_a).toFixed(2);
        nilai_a = Number(nilai_a);
      
      let nilai_b = 0;
      let pertanyaan_b = 4;
        value_b_1 =
            value_b_1 == 'N/A'
            ? (bobot_b_1 = 0, pertanyaan_b--)
            : value_b_1 == ''
            ? 0
            : (nilai_b += Number(value_b_1))          
        value_b_2 =
            value_b_2 == 'N/A'
            ? (bobot_b_2 = 0, pertanyaan_b--)
            : value_b_2 == ''
            ? 0
            : (nilai_b += Number(value_b_2))
        value_b_3 =
            value_b_3 == 'N/A'
            ? (bobot_b_3 = 0, pertanyaan_b--)
            : value_b_3 == ''
            ? 0
            : (nilai_b += Number(value_b_3))
        value_b_4 =
            value_b_4 == 'N/A'
            ? (bobot_b_4 = 0, pertanyaan_b--)
            : value_b_4 == ''
            ? 0
            : (nilai_b += Number(value_b_4))
        let bobot_b = bobot_b_1 + bobot_b_2 + bobot_b_3 + bobot_b_4;
        pertanyaan_b == 0 ? (pertanyaan_b = 1) : pertanyaan_b;    
        nilai_b = (((Number(nilai_b) * bobot_b) / 3) / pertanyaan_b).toFixed(2);
        nilai_b = Number(nilai_b);
          
        value_c_1 =
        value_c_1 == 'N/A'
          ? (bobot_c_1 = 0)
          : value_c_1 == ''
          ? 0
          : Number((((value_c_1 * bobot_c_1)/3)/1).toFixed(2));
      
      let nilai_d = 0;
      let pertanyaan_d = 2;
        value_d_1 =
            value_d_1 == 'N/A'
            ? (bobot_d_1 = 0, pertanyaan_d--)
            : value_d_1 == ''
            ? 0
            : (nilai_d += Number(value_d_1))          
        value_d_2 =
            value_d_2 == 'N/A'
            ? (bobot_d_2 = 0, pertanyaan_d--)
            : value_d_2 == ''
            ? 0
            : (nilai_d += Number(value_d_2))
    
        let bobot_d = bobot_d_1 + bobot_d_2;
        pertanyaan_d == 0 ? (pertanyaan_d = 1) : pertanyaan_d;    
        nilai_d = (((Number(nilai_d) * bobot_d) / 3) / pertanyaan_d).toFixed(2);
        nilai_d = Number(nilai_d);

      let nilai_e = 0;
      let pertanyaan_e = 3;        
        value_e_1 =
            value_e_1 == 'N/A'
            ? (bobot_e_1 = 0, pertanyaan_e--)
            : value_e_1 == ''
            ? 0
            : (nilai_e += Number(value_e_1))          
        value_e_2 =
            value_e_2 == 'N/A'
            ? (bobot_e_2 = 0, pertanyaan_e--)
            : value_e_2 == ''
            ? 0
            : (nilai_e += Number(value_e_2))
        value_e_3 =
            value_e_3 == 'N/A'
            ? (bobot_e_3 = 0, pertanyaan_e--)
            : value_e_3 == ''
            ? 0
            : (nilai_e += Number(value_e_3))

        let bobot_e = bobot_e_1 + bobot_e_2 + bobot_e_3;
        pertanyaan_e == 0 ? (pertanyaan_e = 1) : pertanyaan_e;    
        nilai_e = (((Number(nilai_e) * bobot_e) / 3) / pertanyaan_e).toFixed(2);
        nilai_e = Number(nilai_e);

      let nilai_f = 0;
      let pertanyaan_f = 3;        
        value_f_1 =
            value_f_1 == 'N/A'
            ? (bobot_f_1 = 0, pertanyaan_f--)
            : value_f_1 == ''
            ? 0
            : (nilai_f += Number(value_f_1))          
        value_f_2 =
            value_f_2 == 'N/A'
            ? (bobot_f_2 = 0, pertanyaan_f--)
            : value_f_2 == ''
            ? 0
            : (nilai_f += Number(value_f_2))
        value_f_3 =
            value_f_3 == 'N/A'
            ? (bobot_f_3 = 0, pertanyaan_f--)
            : value_f_3 == ''
            ? 0
            : (nilai_f += Number(value_f_3))
      
          let bobot_f = bobot_f_1 + bobot_f_2 + bobot_f_3;
          pertanyaan_f == 0 ? (pertanyaan_f = 1) : pertanyaan_f;    
          nilai_f = (((Number(nilai_f) * bobot_f) / 3) / pertanyaan_f).toFixed(2);
          nilai_f = Number(nilai_f);

      let nilai_g = 0;
      let pertanyaan_g = 3;        
        value_g_1 =
            value_g_1 == 'N/A'
            ? (bobot_g_1 = 0, pertanyaan_g--)
            : value_g_1 == ''
            ? 0
            : (nilai_g += Number(value_g_1))          
        value_g_2 =
            value_g_2 == 'N/A'
            ? (bobot_g_2 = 0, pertanyaan_g--)
            : value_g_2 == ''
            ? 0
            : (nilai_g += Number(value_g_2))
        value_g_3 =
            value_g_3 == 'N/A'
            ? (bobot_g_3 = 0, pertanyaan_g--)
            : value_g_3 == ''
            ? 0
            : (nilai_g += Number(value_g_3))

          let bobot_g = bobot_g_1 + bobot_g_2 + bobot_g_3;
          pertanyaan_g == 0 ? (pertanyaan_g = 1) : pertanyaan_g;    
          nilai_g = (((Number(nilai_g) * bobot_g) / 3) / pertanyaan_g).toFixed(2);
          nilai_g = Number(nilai_g);

        value_h_1 =
        value_h_1 == 'N/A'
          ? (bobot_h_1 = 0)
          : value_h_1 == ''
          ? 0
          : Number((((value_h_1 * bobot_h_1)/3)/1).toFixed(2));

        let nilai_i2 = 0;
        let pertanyaan_i2 = 3;
          value_i2_1 =
              value_i2_1 == 'N/A'
              ? (bobot_i2_1 = 0, pertanyaan_i2--)
              : value_i2_1 == ''
              ? 0
              : (nilai_i2 += Number(value_i2_1))          
          value_i2_2 =
              value_i2_2 == 'N/A'
              ? (bobot_i2_2 = 0, pertanyaan_i2--)
              : value_i2_2 == ''
              ? 0
              : (nilai_i2 += Number(value_i2_2))
          value_i2_3 =
              value_i2_3 == 'N/A'
              ? (bobot_i2_3 = 0, pertanyaan_i2--)
              : value_i2_3 == ''
              ? 0
              : (nilai_i2 += Number(value_i2_3))
              
            let bobot_i2 = bobot_i2_1 + bobot_i2_2 + bobot_i2_3;
            pertanyaan_i2 == 0 ? (pertanyaan_i2 = 1) : pertanyaan_i2;    
            nilai_i2 = (((Number(nilai_i2) * bobot_i2) / 3) / pertanyaan_i2).toFixed(2);
            nilai_i2 = Number(nilai_i2);

        let nilai_i31 = 0;
        let pertanyaan_i31 = 2;        
          value_i31_1 =
              value_i31_1 == 'N/A'
              ? (bobot_i31_1 = 0, pertanyaan_i31--)
              : value_i31_1 == ''
              ? 0
              : (nilai_i31 += Number(value_i31_1))          
          value_i31_2 =
              value_i31_2 == 'N/A'
              ? (bobot_i31_2 = 0, pertanyaan_i31--)
              : value_i31_2 == ''
              ? 0
              : (nilai_i31 += Number(value_i31_2))
            
            let bobot_i31 = bobot_i31_1 + bobot_i31_2;
            pertanyaan_i31 == 0 ? (pertanyaan_i31 = 1) : pertanyaan_i31;    
            nilai_i31 = (((Number(nilai_i31) * bobot_i31) / 3) / pertanyaan_i31).toFixed(2);
            nilai_i31 = Number(nilai_i31);

      value_i32_1 =
        value_i32_1 == 'N/A'
          ? (bobot_i32_1 = 0)
          : value_i32_1 == ''
          ? 0
          : Number((((value_i32_1 * bobot_i32_1)/3)/1).toFixed(2));

      let nilai_i34 = 0;
      let pertanyaan_i34 = 2;          
        value_i34_1 =
            value_i34_1 == 'N/A'
            ? (bobot_i34_1 = 0, pertanyaan_i34--)
            : value_i34_1 == ''
            ? 0
            : (nilai_i34 += Number(value_i34_1))          
        value_i34_3 =
            value_i34_3 == 'N/A'
            ? (bobot_i34_3 = 0, pertanyaan_i34--)
            : value_i34_3 == ''
            ? 0
            : (nilai_i34 += Number(value_i34_3))
          
          let bobot_i34 = bobot_i34_1 + bobot_i34_3;
          pertanyaan_i34 == 0 ? (pertanyaan_i34 = 1) : pertanyaan_i34;    
          nilai_i34 = (((Number(nilai_i34) * bobot_i34) / 3) / pertanyaan_i34).toFixed(2);
          nilai_i34 = Number(nilai_i34);

      let nilai_i4 = 0;
      let pertanyaan_i4 = 3;                 
        value_i4_1 =
            value_i4_1 == 'N/A'
            ? (bobot_i4_1 = 0, pertanyaan_i4--)
            : value_i4_1 == ''
            ? 0
            : (nilai_i4 += Number(value_i4_1))          
        value_i4_2 =
            value_i4_2 == 'N/A'
            ? (bobot_i4_2 = 0, pertanyaan_i4--)
            : value_i4_2 == ''
            ? 0
            : (nilai_i4 += Number(value_i4_2))          
        value_i4_3 =
            value_i4_3 == 'N/A'
            ? (bobot_i4_3 = 0, pertanyaan_i4--)
            : value_i4_3 == ''
            ? 0
            : (nilai_i4 += Number(value_i4_3))
          let bobot_i4 = bobot_i4_1 + bobot_i4_2 + bobot_i4_3;
          pertanyaan_i4 == 0 ? (pertanyaan_i4 = 1) : pertanyaan_i4;    
          nilai_i4 = (((nilai_i4 * bobot_i4) / 3) / pertanyaan_i4).toFixed(2);
          nilai_i4 = Number(nilai_i4);

      let nilai_i51 = 0;
      let pertanyaan_i51 = 2;
        value_i51_1 =
            value_i51_1 == 'N/A'
            ? (bobot_i51_1 = 0, pertanyaan_i51--)
            : value_i51_1 == ''
            ? 0
            : (nilai_i51 += Number(value_i51_1))          
        value_i51_2 =
            value_i51_2 == 'N/A'
            ? (bobot_i51_2 = 0, pertanyaan_i51--)
            : value_i51_2 == ''
            ? 0
            : (nilai_i51 += Number(value_i51_2))          
          
          let bobot_i51 = bobot_i51_1 + bobot_i51_2;
          pertanyaan_i51 == 0 ? (pertanyaan_i51 = 1) : pertanyaan_i51;    
          nilai_i51 = (((Number(nilai_i51) * bobot_i51) / 3) / pertanyaan_i51).toFixed(2);
          nilai_i51 = Number(nilai_i51);

      let nilai_i52 = 0;
      let pertanyaan_i52 = 3;        
        value_i52_1 =
            value_i52_1 == 'N/A'
            ? (bobot_i52_1 = 0, pertanyaan_i52--)
            : value_i52_1 == ''
            ? 0
            : (nilai_i52 += Number(value_i52_1))          
        value_i52_2 =
            value_i52_2 == 'N/A'
            ? (bobot_i52_2 = 0, pertanyaan_i52--)
            : value_i52_2 == ''
            ? 0
            : (nilai_i52 += Number(value_i52_2))          
        value_i52_3 =
            value_i52_3 == 'N/A'
            ? (bobot_i52_3 = 0, pertanyaan_i52--)
            : value_i52_3 == ''
            ? 0
            : (nilai_i52 += Number(value_i52_3))          
          
          let bobot_i52 = bobot_i52_1 + bobot_i52_2 + bobot_i52_3;
          pertanyaan_i52 == 0 ? (pertanyaan_i52 = 1) : pertanyaan_i52;    
          nilai_i52 = (((Number(nilai_i52) * bobot_i52) / 3) / pertanyaan_i52).toFixed(2);
          nilai_i52 = Number(nilai_i52);

      let nilai_i54 = 0;
      let pertanyaan_i54 = 2;
        value_i54_1 =
            value_i54_1 == 'N/A'
            ? (bobot_i54_1 = 0, pertanyaan_i54--)
            : value_i54_1 == ''
            ? 0
            : (nilai_i54 += Number(value_i54_1))        
        value_i54_3 =
            value_i54_3 == 'N/A'
            ? (bobot_i54_3 = 0, pertanyaan_i54--)
            : value_i54_3 == ''
            ? 0
            : (nilai_i54 += Number(value_i54_3))          
          
          let bobot_i54 = bobot_i54_1 + bobot_i54_3;
          pertanyaan_i54 == 0 ? (pertanyaan_i54 = 1) : pertanyaan_i54;    
          nilai_i54 = (((Number(nilai_i54) * bobot_i54) / 3) / pertanyaan_i54).toFixed(2);
          nilai_i54 = Number(nilai_i54);

      let nilai_i6 = 0;
      let pertanyaan_i6 = 2;
        value_i6_1 =
            value_i6_1 == 'N/A'
            ? (bobot_i6_1 = 0, pertanyaan_i6--)
            : value_i6_1 == ''
            ? 0
            : (nilai_i6 += Number(value_i6_1))        
        value_i6_2 =
            value_i6_2 == 'N/A'
            ? (bobot_i6_2 = 0, pertanyaan_i6--)
            : value_i6_2 == ''
            ? 0
            : (nilai_i6 += Number(value_i6_2))          
          
          let bobot_i6 = bobot_i6_1 + bobot_i6_2;
          pertanyaan_i6 == 0 ? (pertanyaan_i6 = 1) : pertanyaan_i6;    
          nilai_i6 = (((Number(nilai_i6) * bobot_i6) / 3) / pertanyaan_i6).toFixed(2);
          nilai_i6 = Number(nilai_i6);

      let nilai_i7 = 0;
      let pertanyaan_i7 = 2;        
      value_i7_1 =
      value_i7_1 == 'N/A'
      ? (bobot_i7_1 = 0, pertanyaan_i7--)
      : value_i7_1 == ''
      ? 0
      : (nilai_i7 += Number(value_i7_1))        
        value_i7_2 =
        value_i7_2 == 'N/A'
        ? (bobot_i7_2 = 0, pertanyaan_i7--)
        : value_i7_2 == ''
        ? 0
        : (nilai_i7 += Number(value_i7_2))          
        
          let bobot_i7 = bobot_i7_1 + bobot_i7_2; 
          pertanyaan_i7 == 0 ? (pertanyaan_i7 = 1) : pertanyaan_i7;    
          nilai_i7 = (((Number(nilai_i7) * bobot_i7) / 3) / pertanyaan_i7).toFixed(2);
          nilai_i7 = Number(nilai_i7);

      let nilai_i8 = 0;
      let pertanyaan_i8 = 3;        
        value_i8_1 =
            value_i8_1 == 'N/A'
            ? (bobot_i8_1 = 0, pertanyaan_i8--)
            : value_i8_1 == ''
            ? 0
            : (nilai_i8 += Number(value_i8_1))        
        value_i8_2 =
            value_i8_2 == 'N/A'
            ? (bobot_i8_2 = 0, pertanyaan_i8--)
            : value_i8_2 == ''
            ? 0
            : (nilai_i8 += Number(value_i8_2))
        value_i8_3 =
            value_i8_3 == 'N/A'
            ? (bobot_i8_3 = 0, pertanyaan_i8--)
            : value_i8_3 == ''
            ? 0
            : (nilai_i8 += Number(value_i8_3))
            
          let bobot_i8 = bobot_i8_1 + bobot_i8_2 + bobot_i8_3;
          pertanyaan_i8 == 0 ? (pertanyaan_i8 = 1) : pertanyaan_i8;    
          nilai_i8 = (((Number(nilai_i8) * bobot_i8) / 3) / pertanyaan_i8).toFixed(2);
          nilai_i8 = Number(nilai_i8);

      let nilai_i9 = 0;
      let pertanyaan_i9 = 2;        
        value_i9_1 =
            value_i9_1 == 'N/A'
            ? (bobot_i9_1 = 0, pertanyaan_i9--)
            : value_i9_1 == ''
            ? 0
            : (nilai_i9 += Number(value_i9_1))        
        value_i9_2 =
            value_i9_2 == 'N/A'
            ? (bobot_i9_2 = 0, pertanyaan_i9--)
            : value_i9_2 == ''
            ? 0
            : (nilai_i9 += Number(value_i9_2))          

          let bobot_i9 = bobot_i9_1 + bobot_i9_2;
          pertanyaan_i9 == 0 ? (pertanyaan_i9 = 1) : pertanyaan_i9;    
          nilai_i9 = (((Number(nilai_i9) * bobot_i9) / 3) / pertanyaan_i9).toFixed(2);
          nilai_i9 = Number(nilai_i9);

      let nilai_j = 0;
      let pertanyaan_j = 4;        
        value_j_1 =
            value_j_1 == 'N/A'
            ? (bobot_j_1 = 0, pertanyaan_j--)
            : value_j_1 == ''
            ? 0
            : (nilai_j += Number(value_j_1))        
        value_j_2 =
            value_j_2 == 'N/A'
            ? (bobot_j_2 = 0, pertanyaan_j--)
            : value_j_2 == ''
            ? 0
            : (nilai_j += Number(value_j_2))
        value_j_3 =
            value_j_3 == 'N/A'
            ? (bobot_j_3 = 0, pertanyaan_j--)
            : value_j_3 == ''
            ? 0
            : (nilai_j += Number(value_j_3))
        value_j_4 =
            value_j_4 == 'N/A'
            ? (bobot_j_4 = 0, pertanyaan_j--)
            : value_j_4 == ''
            ? 0
            : (nilai_j += Number(value_j_4))
          
          let bobot_j = bobot_j_1 + bobot_j_2 + bobot_j_3 + bobot_j_4;
          pertanyaan_j == 0 ? (pertanyaan_j = 1) : pertanyaan_j;    
          nilai_j = (((Number(nilai_j) * bobot_j) / 3) / pertanyaan_j).toFixed(2);
          nilai_j = Number(nilai_j);

      let nilai_k = 0;
      let pertanyaan_k = 2;
        value_k_1 =
            value_k_1 == 'N/A'
            ? (bobot_k_1 = 0, pertanyaan_k--)
            : value_k_1 == ''
            ? 0
            : (nilai_k += Number(value_k_1))        
        value_k_2 =
            value_k_2 == 'N/A'
            ? (bobot_k_2 = 0, pertanyaan_k--)
            : value_k_2 == ''
            ? 0
            : (nilai_k += Number(value_k_2))
          
          let bobot_k = bobot_k_1 + bobot_k_2;
          pertanyaan_k == 0 ? (pertanyaan_k = 1) : pertanyaan_k;    
          nilai_k = (((Number(nilai_k) * bobot_k) / 3) / pertanyaan_k).toFixed(2);
          nilai_k = Number(nilai_k);

      state.bobot_tinggi =
        bobot_a_2 +
        bobot_c_1 +
        bobot_d_1 +
        bobot_d_2 +
        bobot_e_2 +
        bobot_e_3 +
        bobot_f_1 +
        bobot_f_2 +
        bobot_f_3 +
        bobot_g_1 +
        bobot_i2_1 +
        bobot_i31_1 +
        bobot_i31_2 +
        bobot_i32_1 +
        bobot_i34_1 +
        bobot_i34_3 +
        bobot_i4_1 +
        bobot_i4_2 +
        bobot_i4_3 +
        bobot_i51_1 +
        bobot_i51_2 +
        bobot_i52_2 +
        bobot_i52_3 +
        bobot_i54_1 +
        bobot_i54_3 +
        bobot_i6_1 +
        bobot_i6_2 +
        bobot_i7_1 +
        bobot_i8_2 +
        bobot_i9_1 +
        bobot_j_1 +
        bobot_j_2 +
        bobot_j_3 +
        bobot_j_4 +
        bobot_k_1 +
        state.bobot_sedang


      state.total_tinggi =
        (nilai_a +
        nilai_b +
        value_c_1 +
        nilai_d +
        nilai_e +
        nilai_f +
        nilai_g +
        value_h_1 +
        nilai_i2 +
        nilai_i31 +
        value_i32_1 +
        nilai_i34 +
        nilai_i4 +
        nilai_i51 +
        nilai_i52 +
        nilai_i54 +
        nilai_i6 +
        nilai_i7 +
        nilai_i8 +
        nilai_i9 +
        nilai_j +
        nilai_k).toFixed(2)
        // state.total_sedang
    },
    CAL_SEDANG(state, data) {
      store.commit('kplhStore/CAL_RENDAH')

      let {
        bobot_a_1,
        bobot_b_1,
        bobot_b_3,
        bobot_b_4,
        bobot_g_2,
        bobot_g_3,
        bobot_h_1,
        bobot_i2_2,
        bobot_i2_3,
        bobot_i7_2,
        bobot_i8_3,
        bobot_k_2,

        // Rendah
        bobot_b_2,
        bobot_e_1,
        bobot_i52_1,
        bobot_i8_1,
        bobot_i9_2,

        value_a_1,
        value_b_1,
        value_b_3,
        value_b_4,
        value_g_2,
        value_g_3,
        value_h_1,
        value_i2_2,
        value_i2_3,
        value_i7_2,
        value_i8_3,
        value_k_2,

        // Rendah
        value_b_2,
        value_e_1,
        value_i52_1,
        value_i8_1,
        value_i9_2
      } = state

      let nilai_a = 0
      value_a_1 =
        value_a_1 == 'N/A'
          ? (bobot_a_1 = 0)
          : value_a_1 == ''
          ? 0
          // : (Number(value_a_1) / 3) * bobot_a_1
          // : Number(value_a_1) 
          : nilai_a = ((Number(value_a_1) * bobot_a_1)/3)/1
          // console.log('nilai a--',value_a_1, 'total nilai: ', ((Number(value_a_1) * bobot_a_1)/3)/1, 'bobot: ',bobot_a_1);

          let nilai_b = 0;
          let pertanyaan_b = 4;
          
          value_b_1 =
              value_b_1 == 'N/A'
              ? (bobot_b_1 = 0, pertanyaan_b--)
              : value_b_1 == ''
              ? 0
              : (nilai_b += Number(value_b_1))
          
          value_b_2 =
              value_b_2 == 'N/A'
              ? (bobot_b_2 = 0, pertanyaan_b--)
              : value_b_2 == ''
              ? 0
              : (nilai_b += Number(value_b_2))
          
          value_b_3 =
              value_b_3 == 'N/A'
              ? (bobot_b_3 = 0, pertanyaan_b--)
              : value_b_3 == ''
              ? 0
              : (nilai_b += Number(value_b_3))
          
          value_b_4 =
              value_b_4 == 'N/A'
              ? (bobot_b_4 = 0, pertanyaan_b--)
              : value_b_4 == ''
              ? 0
              : (nilai_b += Number(value_b_4))
          
          let bobot_b = bobot_b_1 + bobot_b_2 + bobot_b_3 + bobot_b_4;
          pertanyaan_b == 0 ? (pertanyaan_b = 1) : pertanyaan_b;
          
          nilai_b = (((Number(nilai_b) * bobot_b) / 3) / pertanyaan_b).toFixed(2);
          nilai_b = Number(nilai_b);

      let nilai_e = 0
      value_e_1 =
        value_e_1 == 'N/A'
          ? (bobot_e_1 = 0)
          : value_e_1 == ''
          ? 0
          : nilai_e = Number((((value_e_1 * bobot_e_1)/3)/1).toFixed(2));

      let nilai_g = 0
      let pertanyaan_g = 2
      value_g_2 =
        value_g_2 == 'N/A'
          ? (bobot_g_2 = 0, pertanyaan_g--)
          : value_g_2 == ''
          ? 0
          : Number(value_g_2)
      value_g_3 =
        value_g_3 == 'N/A'
          ? (bobot_g = 0, pertanyaan_g--)
          : value_g_3 == ''
          ? 0
          : Number(value_g_3)
      
      let bobot_g = bobot_g_2 + bobot_g_3
      pertanyaan_g == 0 ? pertanyaan_g = 1 : pertanyaan_g
      nilai_g = ((((value_g_2 + value_g_3) * bobot_g)/3)/pertanyaan_g).toFixed(2)
      nilai_g = Number(nilai_g)

      let nilai_h = 0
      value_h_1 =
        value_h_1 == 'N/A'
          ? (bobot_h_1 = 0)
          : value_h_1 == ''
          ? 0
          // : (Number(value_h_1) / 3) * bobot_h_1
          : nilai_h = Number((((value_h_1 * bobot_h_1)/3)/1).toFixed(2))

      let nilai_i2 = 0
      let pertanyaan_i2 = 2
      value_i2_2 =
        value_i2_2 == 'N/A'
          ? (bobot_i2_2 = 0, pertanyaan_i2--)
          : value_i2_2 == ''
          ? 0
          : Number(value_i2_2)
      value_i2_3 =
        value_i2_3 == 'N/A'
          ? (bobot_i2_3 = 0, pertanyaan_i2--)
          : value_i2_3 == ''
          ? 0
          : Number(value_i2_3)
      let bobot_i2 = bobot_i2_2 + bobot_i2_3
      pertanyaan_i2 == 0 ? pertanyaan_i2 = 1 : pertanyaan_i2
      nilai_i2 = ((((value_i2_2 + value_i2_3) * bobot_i2)/3)/pertanyaan_i2).toFixed(2)
      nilai_i2 = Number(nilai_i2)

      let nilai_i5 = 0
      value_i52_1 =
        value_i52_1 == 'N/A'
          ? (bobot_i52_1 = 0)
          : value_i52_1 == ''
          ? 0
          : nilai_i5 = Number((((value_i52_1 * bobot_i52_1)/3)/1).toFixed(2))

      let nilai_i7 = 0
      value_i7_2 =
        value_i7_2 == 'N/A'
          ? (bobot_i7_2 = 0)
          : value_i7_2 == ''
          ? 0
          : nilai_i7 = Number((((value_i7_2 * bobot_i7_2)/3)/1).toFixed(2))
      
      let nilai_i8 = 0
      let pertanyaan_i8 = 2
      value_i8_1 =
        value_i8_1 == 'N/A'
          ? (bobot_i8_1 = 0, pertanyaan_i8--)
          : value_i8_1 == ''
              ? 0
          : Number(value_i8_1)
      value_i8_3 =
        value_i8_3 == 'N/A'
          ? (bobot_i8_3 = 0, pertanyaan_i8--)
          : value_i8_3 == ''
              ? 0
          : Number(value_i8_3)
      let bobot_i8 = bobot_i8_1 + bobot_i8_3
      pertanyaan_i8 == 0 ? pertanyaan_i8 = 1 : pertanyaan_i8
      nilai_i8 = ((((value_i8_1 + value_i8_3) * bobot_i8)/3)/pertanyaan_i8).toFixed(2)
      nilai_i8 = Number(nilai_i8)

      let nilai_i9 = 0
      value_i9_2 =
        value_i9_2 == 'N/A'
          ? (bobot_i9_2 = 0)
          : value_i9_2 == ''
          ? 0
          : nilai_i9 = Number((((value_i9_2 * bobot_i9_2)/3)/1).toFixed(2))

      let nilai_k = 0
      value_k_2 =
        value_k_2 == 'N/A'
          ? (bobot_k_2 = 0)
          : value_k_2 == ''
          ? 0
          : nilai_k = Number((((value_k_2 * bobot_k_2)/3)/1).toFixed(2))

      state.bobot_sedang =
        bobot_a_1 +
        bobot_b_1 +
        // bobot_b_2 +
        bobot_b_3 +
        bobot_b_4 +
        bobot_g_2 +
        bobot_g_3 +
        bobot_h_1 +
        bobot_i2_2 +
        bobot_i2_3 +
        bobot_i7_2 +
        bobot_i8_3 +
        bobot_k_2 +
        state.bobot_rendah

      state.total_sedang =
        (nilai_a +
        nilai_b +
        nilai_e +
        nilai_g +
        nilai_h +
        nilai_i2 +
        nilai_i5 +
        nilai_i7 +
        nilai_i8 +
        nilai_i9 +
        nilai_k).toFixed(2)
        // state.total_rendah
    },
    CAL_RENDAH(state, data) {
      let {
        bobot_b_2,
        bobot_e_1,
        bobot_i52_1,
        bobot_i8_1,
        bobot_i9_2,
        value_b_2,
        value_e_1,
        value_i52_1,
        value_i8_1,
        value_i9_2,
      } = state

      let nilai_b = 0
      value_b_2 =
        value_b_2 == 'N/A'
          ? (bobot_b_2 = 0)
          : value_b_2 == ''
          ? 0
          : nilai_b = Number((((value_b_2 * bobot_b_2)/3)/1).toFixed(2));
      
      let nilai_e = 0
      value_e_1 =
        value_e_1 == 'N/A'
          ? (bobot_e_1 = 0)
          : value_e_1 == ''
          ? 0
          : nilai_e = Number((((value_e_1 * bobot_e_1)/3)/1).toFixed(2));

      let nilai_i5 = 0
      value_i52_1 =
        value_i52_1 == 'N/A'
          ? (bobot_i52_1 = 0)
          : value_i52_1 == ''
          ? 0
          : nilai_i5 = Number((((value_i52_1 * bobot_i52_1)/3)/1).toFixed(2));

      let nilai_i8 = 0
      value_i8_1 =
        value_i8_1 == 'N/A'
          ? (bobot_i8_1 = 0)
          : value_i8_1 == ''
          ? 0
          : nilai_i8 = Number((((value_i8_1 * bobot_i8_1)/3)/1).toFixed(2));

      let nilai_i9 = 0
      value_i9_2 =
        value_i9_2 == 'N/A'
          ? (bobot_i9_2 = 0)
          : value_i9_2 == ''
          ? 0
          : nilai_i9 = Number((((value_i9_2 * bobot_i9_2)/3)/1).toFixed(2));

      state.bobot_rendah =
        bobot_b_2 + bobot_e_1 + bobot_i52_1 + bobot_i8_1 + bobot_i9_2
      state.total_rendah =
        nilai_b + nilai_e + nilai_i5 + nilai_i8 + nilai_i9
    },
    async SET_DOCUMENT_LIST(state, data) {
      if (data && data.length > 0) {
        for (let i in data) {
          state[data[i]['landing_page_field']] = data[i]
        }
      }
    },
    async PROCESSING_KPLH(state, payload) {
      const submitedData = {
        request_id: state.request_id,
        pic_name: state.pic_name,
        pic_position: state.pic_position,
        pic_phone: state.pic_phone,
        pic_phone_code: state.pic_phone_code,
        pic_email: state.pic_email,
        gems_company: state.choosed_company,
        bidang_usaha_gems: JSON.stringify(state.addedBidangUsahaGems),
        user_id: state.user_id,
        tingkat_resiko: payload.tingkat_resiko,
        kplh_note_ah: JSON.stringify({
          note_a_1: state.note_a_1,
          note_a_2: state.note_a_2,
          note_b_1: state.note_b_1,
          note_b_2: state.note_b_2,
          note_b_3: state.note_b_3,
          note_b_4: state.note_b_4,
          note_c_1: state.note_c_1,
          note_c_2: state.note_c_2,
          note_d_1: state.note_d_1,
          note_d_2: state.note_d_2,
          note_e_1: state.note_e_1,
          note_e_2: state.note_e_2,
          note_e_3: state.note_e_3,
          note_f_1: state.note_f_1,
          note_f_2: state.note_f_2,
          note_f_3: state.note_f_3,
          note_f_4: state.note_f_4,
          note_g_1: state.note_g_1,
          note_g_2: state.note_g_2,
          note_g_3: state.note_g_3,
          note_h_1: state.note_h_1,

          internal_note_a_1: state.internal_note_a_1,
          internal_note_a_2: state.internal_note_a_2,
          internal_note_b_1: state.internal_note_b_1,
          internal_note_b_2: state.internal_note_b_2,
          internal_note_b_3: state.internal_note_b_3,
          internal_note_b_4: state.internal_note_b_4,
          internal_note_c_1: state.internal_note_c_1,
          internal_note_c_2: state.internal_note_c_2,
          internal_note_d_1: state.internal_note_d_1,
          internal_note_d_2: state.internal_note_d_2,
          internal_note_e_1: state.internal_note_e_1,
          internal_note_e_2: state.internal_note_e_2,
          internal_note_e_3: state.internal_note_e_3,
          internal_note_f_1: state.internal_note_f_1,
          internal_note_f_2: state.internal_note_f_2,
          internal_note_f_3: state.internal_note_f_3,
          internal_note_f_4: state.internal_note_f_4,
          internal_note_g_1: state.internal_note_g_1,
          internal_note_g_2: state.internal_note_g_2,
          internal_note_g_3: state.internal_note_g_3,
          internal_note_h_1: state.internal_note_h_1,
        }),
        kplh_note_i1: JSON.stringify({
          note_i1_1: state.note_i1_1,
          note_i1_2: state.note_i1_2,
          note_i2_1: state.note_i2_1,
          note_i2_2: state.note_i2_2,
          note_i2_3: state.note_i2_3,
          note_i2_4: state.note_i2_4,
          note_i31_1: state.note_i31_1,
          note_i31_2: state.note_i31_2,
          note_i31_3: state.note_i31_3,
          note_i31_4: state.note_i31_4,
          note_i32_1: state.note_i32_1,
          note_i33_1: state.note_i33_1,
          note_i33_2: state.note_i33_2,
          note_i34_1: state.note_i34_1,
          note_i34_2: state.note_i34_2,
          note_i34_3: state.note_i34_3,
          note_i4_1: state.note_i4_1,
          note_i4_2: state.note_i4_2,
          note_i4_3: state.note_i4_3,

          internal_note_i1_1: state.internal_note_i1_1,
          internal_note_i1_2: state.internal_note_i1_2,
          internal_note_i2_1: state.internal_note_i2_1,
          internal_note_i2_2: state.internal_note_i2_2,
          internal_note_i2_3: state.internal_note_i2_3,
          internal_note_i2_4: state.internal_note_i2_4,
          internal_note_i31_1: state.internal_note_i31_1,
          internal_note_i31_2: state.internal_note_i31_2,
          internal_note_i31_3: state.internal_note_i31_3,
          internal_note_i31_4: state.internal_note_i31_4,
          internal_note_i32_1: state.internal_note_i32_1,
          internal_note_i33_1: state.internal_note_i33_1,
          internal_note_i33_2: state.internal_note_i33_2,
          internal_note_i34_1: state.internal_note_i34_1,
          internal_note_i34_2: state.internal_note_i34_2,
          internal_note_i34_3: state.internal_note_i34_3,
          internal_note_i4_1: state.internal_note_i4_1,
          internal_note_i4_2: state.internal_note_i4_2,
          internal_note_i4_3: state.internal_note_i4_3,
        }),
        kplh_note_i2: JSON.stringify({
          note_i51_1: state.note_i51_1,
          note_i51_2: state.note_i51_2,
          note_i52_1: state.note_i52_1,
          note_i52_2: state.note_i52_2,
          note_i52_3: state.note_i52_3,
          note_i53_1: state.note_i53_1,
          note_i53_2: state.note_i53_2,
          note_i54_1: state.note_i54_1,
          note_i54_2: state.note_i54_2,
          note_i54_3: state.note_i54_3,
          note_i6_1: state.note_i6_1,
          note_i6_2: state.note_i6_2,
          note_i7_1: state.note_i7_1,
          note_i7_2: state.note_i7_2,
          note_i8_1: state.note_i8_1,
          note_i8_2: state.note_i8_2,
          note_i8_3: state.note_i8_3,
          note_i9_1: state.note_i9_1,
          note_i9_2: state.note_i9_2,

          internal_note_i51_1: state.internal_note_i51_1,
          internal_note_i51_2: state.internal_note_i51_2,
          internal_note_i52_1: state.internal_note_i52_1,
          internal_note_i52_2: state.internal_note_i52_2,
          internal_note_i52_3: state.internal_note_i52_3,
          internal_note_i53_1: state.internal_note_i53_1,
          internal_note_i53_2: state.internal_note_i53_2,
          internal_note_i54_1: state.internal_note_i54_1,
          internal_note_i54_2: state.internal_note_i54_2,
          internal_note_i54_3: state.internal_note_i54_3,
          internal_note_i6_1: state.internal_note_i6_1,
          internal_note_i6_2: state.internal_note_i6_2,
          internal_note_i7_1: state.internal_note_i7_1,
          internal_note_i7_2: state.internal_note_i7_2,
          internal_note_i8_1: state.internal_note_i8_1,
          internal_note_i8_2: state.internal_note_i8_2,
          internal_note_i8_3: state.internal_note_i8_3,
          internal_note_i9_1: state.internal_note_i9_1,
          internal_note_i9_2: state.internal_note_i9_2,
        }),
        kplh_note_jm: JSON.stringify({
          note_j_1: state.note_j_1,
          note_j_2: state.note_j_2,
          note_j_3: state.note_j_3,
          note_j_4: state.note_j_4,
          note_k_1: state.note_k_1,
          note_k_2: state.note_k_2,
          note_l_1: state.note_l_1,
          note_l_2: state.note_l_2,
          note_l_3: state.note_l_3,
          note_m_1: state.note_m_1,
          note_m_2: state.note_m_2,
          note_m_3: state.note_m_3,

          internal_note_j_1: state.internal_note_j_1,
          internal_note_j_2: state.internal_note_j_2,
          internal_note_j_3: state.internal_note_j_3,
          internal_note_j_4: state.internal_note_j_4,
          internal_note_k_1: state.internal_note_k_1,
          internal_note_k_2: state.internal_note_k_2,
          internal_note_l_1: state.internal_note_l_1,
          internal_note_l_2: state.internal_note_l_2,
          internal_note_l_3: state.internal_note_l_3,
          internal_note_m_1: state.internal_note_m_1,
          internal_note_m_2: state.internal_note_m_2,
          internal_note_m_3: state.internal_note_m_3,
        }),
      }

      state.globalLoading = true
      axios({
        method: 'POST',
        url: `${api_lp}/api/v1/vendor/kplh`,
        data: submitedData,
        // headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          console.log(
            '🚀 ~ file: kplhStore.js ~ line 503 ~ .then ~ response',
            response
          )
          state.globalLoading = false
          state.is_vendor_done = true
          state.is_sipm_validation = true
          store.commit('SET_NOTIF', 'Submit Data KPLH Berhasil!')
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: kplhStore.js ~ line 507 ~ PROCESSING_KPLH ~ error',
            error
          )

          state.globalLoading = false
          store.commit(
            'SET_NOTIF',
            mixin.methods.$get(error, 'response.data.message', 'Error')
          )
        })
    },
    async PROCESSING_KPLH_FOR_DRAFT(state, payload) {
      const submitedData = {
        request_id: state.request_id,
        pic_name: state.pic_name,
        pic_position: state.pic_position,
        pic_phone: state.pic_phone,
        pic_phone_code: state.pic_phone_code,
        pic_email: state.pic_email,
        gems_company: state.choosed_company,
        bidang_usaha_gems: JSON.stringify(state.addedBidangUsahaGems),
        user_id: state.user_id,
        tingkat_resiko: payload.tingkat_resiko,
        kplh_note_ah: JSON.stringify({
          note_a_1: state.note_a_1,
          note_a_2: state.note_a_2,
          note_b_1: state.note_b_1,
          note_b_2: state.note_b_2,
          note_b_3: state.note_b_3,
          note_b_4: state.note_b_4,
          note_c_1: state.note_c_1,
          note_c_2: state.note_c_2,
          note_d_1: state.note_d_1,
          note_d_2: state.note_d_2,
          note_e_1: state.note_e_1,
          note_e_2: state.note_e_2,
          note_e_3: state.note_e_3,
          note_f_1: state.note_f_1,
          note_f_2: state.note_f_2,
          note_f_3: state.note_f_3,
          note_f_4: state.note_f_4,
          note_g_1: state.note_g_1,
          note_g_2: state.note_g_2,
          note_g_3: state.note_g_3,
          note_h_1: state.note_h_1,

          internal_note_a_1: state.internal_note_a_1,
          internal_note_a_2: state.internal_note_a_2,
          internal_note_b_1: state.internal_note_b_1,
          internal_note_b_2: state.internal_note_b_2,
          internal_note_b_3: state.internal_note_b_3,
          internal_note_b_4: state.internal_note_b_4,
          internal_note_c_1: state.internal_note_c_1,
          internal_note_c_2: state.internal_note_c_2,
          internal_note_d_1: state.internal_note_d_1,
          internal_note_d_2: state.internal_note_d_2,
          internal_note_e_1: state.internal_note_e_1,
          internal_note_e_2: state.internal_note_e_2,
          internal_note_e_3: state.internal_note_e_3,
          internal_note_f_1: state.internal_note_f_1,
          internal_note_f_2: state.internal_note_f_2,
          internal_note_f_3: state.internal_note_f_3,
          internal_note_f_4: state.internal_note_f_4,
          internal_note_g_1: state.internal_note_g_1,
          internal_note_g_2: state.internal_note_g_2,
          internal_note_g_3: state.internal_note_g_3,
          internal_note_h_1: state.internal_note_h_1,
        }),
        kplh_note_i1: JSON.stringify({
          note_i1_1: state.note_i1_1,
          note_i1_2: state.note_i1_2,
          note_i2_1: state.note_i2_1,
          note_i2_2: state.note_i2_2,
          note_i2_3: state.note_i2_3,
          note_i2_4: state.note_i2_4,
          note_i31_1: state.note_i31_1,
          note_i31_2: state.note_i31_2,
          note_i31_3: state.note_i31_3,
          note_i31_4: state.note_i31_4,
          note_i32_1: state.note_i32_1,
          note_i33_1: state.note_i33_1,
          note_i33_2: state.note_i33_2,
          note_i34_1: state.note_i34_1,
          note_i34_2: state.note_i34_2,
          note_i34_3: state.note_i34_3,
          note_i4_1: state.note_i4_1,
          note_i4_2: state.note_i4_2,
          note_i4_3: state.note_i4_3,

          internal_note_i1_1: state.internal_note_i1_1,
          internal_note_i1_2: state.internal_note_i1_2,
          internal_note_i2_1: state.internal_note_i2_1,
          internal_note_i2_2: state.internal_note_i2_2,
          internal_note_i2_3: state.internal_note_i2_3,
          internal_note_i2_4: state.internal_note_i2_4,
          internal_note_i31_1: state.internal_note_i31_1,
          internal_note_i31_2: state.internal_note_i31_2,
          internal_note_i31_3: state.internal_note_i31_3,
          internal_note_i31_4: state.internal_note_i31_4,
          internal_note_i32_1: state.internal_note_i32_1,
          internal_note_i33_1: state.internal_note_i33_1,
          internal_note_i33_2: state.internal_note_i33_2,
          internal_note_i34_1: state.internal_note_i34_1,
          internal_note_i34_2: state.internal_note_i34_2,
          internal_note_i34_3: state.internal_note_i34_3,
          internal_note_i4_1: state.internal_note_i4_1,
          internal_note_i4_2: state.internal_note_i4_2,
          internal_note_i4_3: state.internal_note_i4_3,
        }),
        kplh_note_i2: JSON.stringify({
          note_i51_1: state.note_i51_1,
          note_i51_2: state.note_i51_2,
          note_i52_1: state.note_i52_1,
          note_i52_2: state.note_i52_2,
          note_i52_3: state.note_i52_3,
          note_i53_1: state.note_i53_1,
          note_i53_2: state.note_i53_2,
          note_i54_1: state.note_i54_1,
          note_i54_2: state.note_i54_2,
          note_i54_3: state.note_i54_3,
          note_i6_1: state.note_i6_1,
          note_i6_2: state.note_i6_2,
          note_i7_1: state.note_i7_1,
          note_i7_2: state.note_i7_2,
          note_i8_1: state.note_i8_1,
          note_i8_2: state.note_i8_2,
          note_i8_3: state.note_i8_3,
          note_i9_1: state.note_i9_1,
          note_i9_2: state.note_i9_2,

          internal_note_i51_1: state.internal_note_i51_1,
          internal_note_i51_2: state.internal_note_i51_2,
          internal_note_i52_1: state.internal_note_i52_1,
          internal_note_i52_2: state.internal_note_i52_2,
          internal_note_i52_3: state.internal_note_i52_3,
          internal_note_i53_1: state.internal_note_i53_1,
          internal_note_i53_2: state.internal_note_i53_2,
          internal_note_i54_1: state.internal_note_i54_1,
          internal_note_i54_2: state.internal_note_i54_2,
          internal_note_i54_3: state.internal_note_i54_3,
          internal_note_i6_1: state.internal_note_i6_1,
          internal_note_i6_2: state.internal_note_i6_2,
          internal_note_i7_1: state.internal_note_i7_1,
          internal_note_i7_2: state.internal_note_i7_2,
          internal_note_i8_1: state.internal_note_i8_1,
          internal_note_i8_2: state.internal_note_i8_2,
          internal_note_i8_3: state.internal_note_i8_3,
          internal_note_i9_1: state.internal_note_i9_1,
          internal_note_i9_2: state.internal_note_i9_2,
        }),
        kplh_note_jm: JSON.stringify({
          note_j_1: state.note_j_1,
          note_j_2: state.note_j_2,
          note_j_3: state.note_j_3,
          note_j_4: state.note_j_4,
          note_k_1: state.note_k_1,
          note_k_2: state.note_k_2,
          note_l_1: state.note_l_1,
          note_l_2: state.note_l_2,
          note_l_3: state.note_l_3,
          note_m_1: state.note_m_1,
          note_m_2: state.note_m_2,
          note_m_3: state.note_m_3,

          internal_note_j_1: state.internal_note_j_1,
          internal_note_j_2: state.internal_note_j_2,
          internal_note_j_3: state.internal_note_j_3,
          internal_note_j_4: state.internal_note_j_4,
          internal_note_k_1: state.internal_note_k_1,
          internal_note_k_2: state.internal_note_k_2,
          internal_note_l_1: state.internal_note_l_1,
          internal_note_l_2: state.internal_note_l_2,
          internal_note_l_3: state.internal_note_l_3,
          internal_note_m_1: state.internal_note_m_1,
          internal_note_m_2: state.internal_note_m_2,
          internal_note_m_3: state.internal_note_m_3,
        }),
      }

      state.globalLoading = true
      axios({
        method: 'POST',
        url: `${api_lp}/api/v1/vendor/kplh-draft`,
        data: submitedData,
        // headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          console.log(
            '🚀 ~ file: kplhStore.js ~ line 503 ~ .then ~ response',
            response
          )
          state.globalLoading = false
          payload.onSuccess()
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: kplhStore.js ~ line 507 ~ PROCESSING_KPLH ~ error',
            error
          )

          state.globalLoading = false
          store.commit(
            'SET_NOTIF',
            mixin.methods.$get(error, 'response.data.message', 'Error')
          )
        })
    },
    async SUBMIT_PENILAIAN(state, payload) {
      const submitedData = {
        request_id: state.request_id,
        // total_result: state.total_result,
        kplh_note_ah: JSON.stringify({
          note_a_1: state.note_a_1,
          note_a_2: state.note_a_2,
          note_b_1: state.note_b_1,
          note_b_2: state.note_b_2,
          note_b_3: state.note_b_3,
          note_b_4: state.note_b_4,
          note_c_1: state.note_c_1,
          note_c_2: state.note_c_2,
          note_d_1: state.note_d_1,
          note_d_2: state.note_d_2,
          note_e_1: state.note_e_1,
          note_e_2: state.note_e_2,
          note_e_3: state.note_e_3,
          note_f_1: state.note_f_1,
          note_f_2: state.note_f_2,
          note_f_3: state.note_f_3,
          note_f_4: state.note_f_4,
          note_g_1: state.note_g_1,
          note_g_2: state.note_g_2,
          note_g_3: state.note_g_3,
          note_h_1: state.note_h_1,

          internal_note_a_1: state.internal_note_a_1,
          internal_note_a_2: state.internal_note_a_2,
          internal_note_b_1: state.internal_note_b_1,
          internal_note_b_2: state.internal_note_b_2,
          internal_note_b_3: state.internal_note_b_3,
          internal_note_b_4: state.internal_note_b_4,
          internal_note_c_1: state.internal_note_c_1,
          internal_note_c_2: state.internal_note_c_2,
          internal_note_d_1: state.internal_note_d_1,
          internal_note_d_2: state.internal_note_d_2,
          internal_note_e_1: state.internal_note_e_1,
          internal_note_e_2: state.internal_note_e_2,
          internal_note_e_3: state.internal_note_e_3,
          internal_note_f_1: state.internal_note_f_1,
          internal_note_f_2: state.internal_note_f_2,
          internal_note_f_3: state.internal_note_f_3,
          internal_note_f_4: state.internal_note_f_4,
          internal_note_g_1: state.internal_note_g_1,
          internal_note_g_2: state.internal_note_g_2,
          internal_note_g_3: state.internal_note_g_3,
          internal_note_h_1: state.internal_note_h_1,
        }),
        kplh_note_i1: JSON.stringify({
          note_i1_1: state.note_i1_1,
          note_i1_2: state.note_i1_2,
          note_i2_1: state.note_i2_1,
          note_i2_2: state.note_i2_2,
          note_i2_3: state.note_i2_3,
          note_i2_4: state.note_i2_4,
          note_i31_1: state.note_i31_1,
          note_i31_2: state.note_i31_2,
          note_i31_3: state.note_i31_3,
          note_i31_4: state.note_i31_4,
          note_i32_1: state.note_i32_1,
          note_i33_1: state.note_i33_1,
          note_i33_2: state.note_i33_2,
          note_i34_1: state.note_i34_1,
          note_i34_2: state.note_i34_2,
          note_i34_3: state.note_i34_3,
          note_i4_1: state.note_i4_1,
          note_i4_2: state.note_i4_2,
          note_i4_3: state.note_i4_3,

          internal_note_i1_1: state.internal_note_i1_1,
          internal_note_i1_2: state.internal_note_i1_2,
          internal_note_i2_1: state.internal_note_i2_1,
          internal_note_i2_2: state.internal_note_i2_2,
          internal_note_i2_3: state.internal_note_i2_3,
          internal_note_i2_4: state.internal_note_i2_4,
          internal_note_i31_1: state.internal_note_i31_1,
          internal_note_i31_2: state.internal_note_i31_2,
          internal_note_i31_3: state.internal_note_i31_3,
          internal_note_i31_4: state.internal_note_i31_4,
          internal_note_i32_1: state.internal_note_i32_1,
          internal_note_i33_1: state.internal_note_i33_1,
          internal_note_i33_2: state.internal_note_i33_2,
          internal_note_i34_1: state.internal_note_i34_1,
          internal_note_i34_2: state.internal_note_i34_2,
          internal_note_i34_3: state.internal_note_i34_3,
          internal_note_i4_1: state.internal_note_i4_1,
          internal_note_i4_2: state.internal_note_i4_2,
          internal_note_i4_3: state.internal_note_i4_3,
        }),
        kplh_note_i2: JSON.stringify({
          note_i51_1: state.note_i51_1,
          note_i51_2: state.note_i51_2,
          note_i52_1: state.note_i52_1,
          note_i52_2: state.note_i52_2,
          note_i52_3: state.note_i52_3,
          note_i53_1: state.note_i53_1,
          note_i53_2: state.note_i53_2,
          note_i54_1: state.note_i54_1,
          note_i54_2: state.note_i54_2,
          note_i54_3: state.note_i54_3,
          note_i6_1: state.note_i6_1,
          note_i6_2: state.note_i6_2,
          note_i7_1: state.note_i7_1,
          note_i7_2: state.note_i7_2,
          note_i8_1: state.note_i8_1,
          note_i8_2: state.note_i8_2,
          note_i8_3: state.note_i8_3,
          note_i9_1: state.note_i9_1,
          note_i9_2: state.note_i9_2,

          internal_note_i51_1: state.internal_note_i51_1,
          internal_note_i51_2: state.internal_note_i51_2,
          internal_note_i52_1: state.internal_note_i52_1,
          internal_note_i52_2: state.internal_note_i52_2,
          internal_note_i52_3: state.internal_note_i52_3,
          internal_note_i53_1: state.internal_note_i53_1,
          internal_note_i53_2: state.internal_note_i53_2,
          internal_note_i54_1: state.internal_note_i54_1,
          internal_note_i54_2: state.internal_note_i54_2,
          internal_note_i54_3: state.internal_note_i54_3,
          internal_note_i6_1: state.internal_note_i6_1,
          internal_note_i6_2: state.internal_note_i6_2,
          internal_note_i7_1: state.internal_note_i7_1,
          internal_note_i7_2: state.internal_note_i7_2,
          internal_note_i8_1: state.internal_note_i8_1,
          internal_note_i8_2: state.internal_note_i8_2,
          internal_note_i8_3: state.internal_note_i8_3,
          internal_note_i9_1: state.internal_note_i9_1,
          internal_note_i9_2: state.internal_note_i9_2,
        }),
        kplh_note_jm: JSON.stringify({
          note_j_1: state.note_j_1,
          note_j_2: state.note_j_2,
          note_j_3: state.note_j_3,
          note_j_4: state.note_j_4,
          note_k_1: state.note_k_1,
          note_k_2: state.note_k_2,
          note_l_1: state.note_l_1,
          note_l_2: state.note_l_2,
          note_l_3: state.note_l_3,
          note_m_1: state.note_m_1,
          note_m_2: state.note_m_2,
          note_m_3: state.note_m_3,

          internal_note_j_1: state.internal_note_j_1,
          internal_note_j_2: state.internal_note_j_2,
          internal_note_j_3: state.internal_note_j_3,
          internal_note_j_4: state.internal_note_j_4,
          internal_note_k_1: state.internal_note_k_1,
          internal_note_k_2: state.internal_note_k_2,
          internal_note_l_1: state.internal_note_l_1,
          internal_note_l_2: state.internal_note_l_2,
          internal_note_l_3: state.internal_note_l_3,
          internal_note_m_1: state.internal_note_m_1,
          internal_note_m_2: state.internal_note_m_2,
          internal_note_m_3: state.internal_note_m_3,
        }),
        kplh_value_ah: JSON.stringify({
          value_a_1: state.value_a_1,
          value_a_2: state.value_a_2,
          value_b_1: state.value_b_1,
          value_b_2: state.value_b_2,
          value_b_3: state.value_b_3,
          value_b_4: state.value_b_4,
          value_c_1: state.value_c_1,
          value_c_2: state.value_c_2,
          value_d_1: state.value_d_1,
          value_d_2: state.value_d_2,
          value_e_1: state.value_e_1,
          value_e_2: state.value_e_2,
          value_e_3: state.value_e_3,
          value_f_1: state.value_f_1,
          value_f_2: state.value_f_2,
          value_f_3: state.value_f_3,
          value_f_4: state.value_f_4,
          value_g_1: state.value_g_1,
          value_g_2: state.value_g_2,
          value_g_3: state.value_g_3,
          value_h_1: state.value_h_1,
        }),
        kplh_value_i1: JSON.stringify({
          value_i1_1: state.value_i1_1,
          value_i1_2: state.value_i1_2,
          value_i2_1: state.value_i2_1,
          value_i2_2: state.value_i2_2,
          value_i2_3: state.value_i2_3,
          value_i2_4: state.value_i2_4,
          value_i31_1: state.value_i31_1,
          value_i31_2: state.value_i31_2,
          value_i31_3: state.value_i31_3,
          value_i31_4: state.value_i31_4,
          value_i32_1: state.value_i32_1,
          value_i33_1: state.value_i33_1,
          value_i33_2: state.value_i33_2,
          value_i34_1: state.value_i34_1,
          value_i34_2: state.value_i34_2,
          value_i34_3: state.value_i34_3,
          value_i4_1: state.value_i4_1,
          value_i4_2: state.value_i4_2,
          value_i4_3: state.value_i4_3,
        }),
        kplh_value_i2: JSON.stringify({
          value_i51_1: state.value_i51_1,
          value_i51_2: state.value_i51_2,
          value_i52_1: state.value_i52_1,
          value_i52_2: state.value_i52_2,
          value_i52_3: state.value_i52_3,
          value_i53_1: state.value_i53_1,
          value_i53_2: state.value_i53_2,
          value_i54_1: state.value_i54_1,
          value_i54_2: state.value_i54_2,
          value_i54_3: state.value_i54_3,
          value_i6_1: state.value_i6_1,
          value_i6_2: state.value_i6_2,
          value_i7_1: state.value_i7_1,
          value_i7_2: state.value_i7_2,
          value_i8_1: state.value_i8_1,
          value_i8_2: state.value_i8_2,
          value_i8_3: state.value_i8_3,
          value_i9_1: state.value_i9_1,
          value_i9_2: state.value_i9_2,
        }),
        kplh_value_jm: JSON.stringify({
          value_j_1: state.value_j_1,
          value_j_2: state.value_j_2,
          value_j_3: state.value_j_3,
          value_j_4: state.value_j_4,
          value_k_1: state.value_k_1,
          value_k_2: state.value_k_2,
          value_l_1: state.value_l_1,
          value_l_2: state.value_l_2,
          value_l_3: state.value_l_3,
          value_m_1: state.value_m_1,
          value_m_2: state.value_m_2,
          value_m_3: state.value_m_3,
        }),
        total_result: payload.final_result,
        user_id: state.user_id,
        final_result: state.final_result_notes,
        head_hse_id: state.tdd_head_hse,
        ktt_id: state.tdd_ktt,
        catatan: state.catatan,
        posision: 'HSE',
        tingkat_resiko: payload.tingkat_resiko,
      }

      state.globalLoading = true
      axios({
        method: 'POST',
        url: `${api_lp}/api/v1/vendor/kplh-penilaian`,
        data: submitedData,
        // headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          console.log(
            '🚀 ~ file: kplhStore.js ~ line 503 ~ .then ~ response',
            response
          )
          state.globalLoading = false
          state.is_hse_validation = true
          store.commit('SET_NOTIF', 'Submit Data KPLH Berhasil!')
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: kplhStore.js ~ line 507 ~ PROCESSING_KPLH ~ error',
            error
          )

          state.globalLoading = false
          store.commit(
            'SET_NOTIF',
            mixin.methods.$get(error, 'response.data.message', 'Error')
          )
        })
    },
    async SUBMIT_PENILAIAN_FOR_DRAFT(state, payload) {
      const submitedData = {
        request_id: state.request_id,
        // total_result: state.total_result,
        kplh_note_ah: JSON.stringify({
          note_a_1: state.note_a_1,
          note_a_2: state.note_a_2,
          note_b_1: state.note_b_1,
          note_b_2: state.note_b_2,
          note_b_3: state.note_b_3,
          note_b_4: state.note_b_4,
          note_c_1: state.note_c_1,
          note_c_2: state.note_c_2,
          note_d_1: state.note_d_1,
          note_d_2: state.note_d_2,
          note_e_1: state.note_e_1,
          note_e_2: state.note_e_2,
          note_e_3: state.note_e_3,
          note_f_1: state.note_f_1,
          note_f_2: state.note_f_2,
          note_f_3: state.note_f_3,
          note_f_4: state.note_f_4,
          note_g_1: state.note_g_1,
          note_g_2: state.note_g_2,
          note_g_3: state.note_g_3,
          note_h_1: state.note_h_1,

          internal_note_a_1: state.internal_note_a_1,
          internal_note_a_2: state.internal_note_a_2,
          internal_note_b_1: state.internal_note_b_1,
          internal_note_b_2: state.internal_note_b_2,
          internal_note_b_3: state.internal_note_b_3,
          internal_note_b_4: state.internal_note_b_4,
          internal_note_c_1: state.internal_note_c_1,
          internal_note_c_2: state.internal_note_c_2,
          internal_note_d_1: state.internal_note_d_1,
          internal_note_d_2: state.internal_note_d_2,
          internal_note_e_1: state.internal_note_e_1,
          internal_note_e_2: state.internal_note_e_2,
          internal_note_e_3: state.internal_note_e_3,
          internal_note_f_1: state.internal_note_f_1,
          internal_note_f_2: state.internal_note_f_2,
          internal_note_f_3: state.internal_note_f_3,
          internal_note_f_4: state.internal_note_f_4,
          internal_note_g_1: state.internal_note_g_1,
          internal_note_g_2: state.internal_note_g_2,
          internal_note_g_3: state.internal_note_g_3,
          internal_note_h_1: state.internal_note_h_1,
        }),
        kplh_note_i1: JSON.stringify({
          note_i1_1: state.note_i1_1,
          note_i1_2: state.note_i1_2,
          note_i2_1: state.note_i2_1,
          note_i2_2: state.note_i2_2,
          note_i2_3: state.note_i2_3,
          note_i2_4: state.note_i2_4,
          note_i31_1: state.note_i31_1,
          note_i31_2: state.note_i31_2,
          note_i31_3: state.note_i31_3,
          note_i31_4: state.note_i31_4,
          note_i32_1: state.note_i32_1,
          note_i33_1: state.note_i33_1,
          note_i33_2: state.note_i33_2,
          note_i34_1: state.note_i34_1,
          note_i34_2: state.note_i34_2,
          note_i34_3: state.note_i34_3,
          note_i4_1: state.note_i4_1,
          note_i4_2: state.note_i4_2,
          note_i4_3: state.note_i4_3,

          internal_note_i1_1: state.internal_note_i1_1,
          internal_note_i1_2: state.internal_note_i1_2,
          internal_note_i2_1: state.internal_note_i2_1,
          internal_note_i2_2: state.internal_note_i2_2,
          internal_note_i2_3: state.internal_note_i2_3,
          internal_note_i2_4: state.internal_note_i2_4,
          internal_note_i31_1: state.internal_note_i31_1,
          internal_note_i31_2: state.internal_note_i31_2,
          internal_note_i31_3: state.internal_note_i31_3,
          internal_note_i31_4: state.internal_note_i31_4,
          internal_note_i32_1: state.internal_note_i32_1,
          internal_note_i33_1: state.internal_note_i33_1,
          internal_note_i33_2: state.internal_note_i33_2,
          internal_note_i34_1: state.internal_note_i34_1,
          internal_note_i34_2: state.internal_note_i34_2,
          internal_note_i34_3: state.internal_note_i34_3,
          internal_note_i4_1: state.internal_note_i4_1,
          internal_note_i4_2: state.internal_note_i4_2,
          internal_note_i4_3: state.internal_note_i4_3,
        }),
        kplh_note_i2: JSON.stringify({
          note_i51_1: state.note_i51_1,
          note_i51_2: state.note_i51_2,
          note_i52_1: state.note_i52_1,
          note_i52_2: state.note_i52_2,
          note_i52_3: state.note_i52_3,
          note_i53_1: state.note_i53_1,
          note_i53_2: state.note_i53_2,
          note_i54_1: state.note_i54_1,
          note_i54_2: state.note_i54_2,
          note_i54_3: state.note_i54_3,
          note_i6_1: state.note_i6_1,
          note_i6_2: state.note_i6_2,
          note_i7_1: state.note_i7_1,
          note_i7_2: state.note_i7_2,
          note_i8_1: state.note_i8_1,
          note_i8_2: state.note_i8_2,
          note_i8_3: state.note_i8_3,
          note_i9_1: state.note_i9_1,
          note_i9_2: state.note_i9_2,

          internal_note_i51_1: state.internal_note_i51_1,
          internal_note_i51_2: state.internal_note_i51_2,
          internal_note_i52_1: state.internal_note_i52_1,
          internal_note_i52_2: state.internal_note_i52_2,
          internal_note_i52_3: state.internal_note_i52_3,
          internal_note_i53_1: state.internal_note_i53_1,
          internal_note_i53_2: state.internal_note_i53_2,
          internal_note_i54_1: state.internal_note_i54_1,
          internal_note_i54_2: state.internal_note_i54_2,
          internal_note_i54_3: state.internal_note_i54_3,
          internal_note_i6_1: state.internal_note_i6_1,
          internal_note_i6_2: state.internal_note_i6_2,
          internal_note_i7_1: state.internal_note_i7_1,
          internal_note_i7_2: state.internal_note_i7_2,
          internal_note_i8_1: state.internal_note_i8_1,
          internal_note_i8_2: state.internal_note_i8_2,
          internal_note_i8_3: state.internal_note_i8_3,
          internal_note_i9_1: state.internal_note_i9_1,
          internal_note_i9_2: state.internal_note_i9_2,
        }),
        kplh_note_jm: JSON.stringify({
          note_j_1: state.note_j_1,
          note_j_2: state.note_j_2,
          note_j_3: state.note_j_3,
          note_j_4: state.note_j_4,
          note_k_1: state.note_k_1,
          note_k_2: state.note_k_2,
          note_l_1: state.note_l_1,
          note_l_2: state.note_l_2,
          note_l_3: state.note_l_3,
          note_m_1: state.note_m_1,
          note_m_2: state.note_m_2,
          note_m_3: state.note_m_3,

          internal_note_j_1: state.internal_note_j_1,
          internal_note_j_2: state.internal_note_j_2,
          internal_note_j_3: state.internal_note_j_3,
          internal_note_j_4: state.internal_note_j_4,
          internal_note_k_1: state.internal_note_k_1,
          internal_note_k_2: state.internal_note_k_2,
          internal_note_l_1: state.internal_note_l_1,
          internal_note_l_2: state.internal_note_l_2,
          internal_note_l_3: state.internal_note_l_3,
          internal_note_m_1: state.internal_note_m_1,
          internal_note_m_2: state.internal_note_m_2,
          internal_note_m_3: state.internal_note_m_3,
        }),
        kplh_value_ah: JSON.stringify({
          value_a_1: state.value_a_1,
          value_a_2: state.value_a_2,
          value_b_1: state.value_b_1,
          value_b_2: state.value_b_2,
          value_b_3: state.value_b_3,
          value_b_4: state.value_b_4,
          value_c_1: state.value_c_1,
          value_c_2: state.value_c_2,
          value_d_1: state.value_d_1,
          value_d_2: state.value_d_2,
          value_e_1: state.value_e_1,
          value_e_2: state.value_e_2,
          value_e_3: state.value_e_3,
          value_f_1: state.value_f_1,
          value_f_2: state.value_f_2,
          value_f_3: state.value_f_3,
          value_f_4: state.value_f_4,
          value_g_1: state.value_g_1,
          value_g_2: state.value_g_2,
          value_g_3: state.value_g_3,
          value_h_1: state.value_h_1,
        }),
        kplh_value_i1: JSON.stringify({
          value_i1_1: state.value_i1_1,
          value_i1_2: state.value_i1_2,
          value_i2_1: state.value_i2_1,
          value_i2_2: state.value_i2_2,
          value_i2_3: state.value_i2_3,
          value_i2_4: state.value_i2_4,
          value_i31_1: state.value_i31_1,
          value_i31_2: state.value_i31_2,
          value_i31_3: state.value_i31_3,
          value_i31_4: state.value_i31_4,
          value_i32_1: state.value_i32_1,
          value_i33_1: state.value_i33_1,
          value_i33_2: state.value_i33_2,
          value_i34_1: state.value_i34_1,
          value_i34_2: state.value_i34_2,
          value_i34_3: state.value_i34_3,
          value_i4_1: state.value_i4_1,
          value_i4_2: state.value_i4_2,
          value_i4_3: state.value_i4_3,
        }),
        kplh_value_i2: JSON.stringify({
          value_i51_1: state.value_i51_1,
          value_i51_2: state.value_i51_2,
          value_i52_1: state.value_i52_1,
          value_i52_2: state.value_i52_2,
          value_i52_3: state.value_i52_3,
          value_i53_1: state.value_i53_1,
          value_i53_2: state.value_i53_2,
          value_i54_1: state.value_i54_1,
          value_i54_2: state.value_i54_2,
          value_i54_3: state.value_i54_3,
          value_i6_1: state.value_i6_1,
          value_i6_2: state.value_i6_2,
          value_i7_1: state.value_i7_1,
          value_i7_2: state.value_i7_2,
          value_i8_1: state.value_i8_1,
          value_i8_2: state.value_i8_2,
          value_i8_3: state.value_i8_3,
          value_i9_1: state.value_i9_1,
          value_i9_2: state.value_i9_2,
        }),
        kplh_value_jm: JSON.stringify({
          value_j_1: state.value_j_1,
          value_j_2: state.value_j_2,
          value_j_3: state.value_j_3,
          value_j_4: state.value_j_4,
          value_k_1: state.value_k_1,
          value_k_2: state.value_k_2,
          value_l_1: state.value_l_1,
          value_l_2: state.value_l_2,
          value_l_3: state.value_l_3,
          value_m_1: state.value_m_1,
          value_m_2: state.value_m_2,
          value_m_3: state.value_m_3,
        }),
        total_result: payload.final_result,
        user_id: state.user_id,
        final_result: state.final_result_notes,
        head_hse_id: state.tdd_head_hse,
        ktt_id: state.tdd_ktt,
        catatan: state.catatan,
        posision: 'HSE',
        tingkat_resiko: payload.tingkat_resiko,
      }

      state.globalLoading = true
      axios({
        method: 'POST',
        url: `${api_lp}/api/v1/vendor/kplh-penilaian-draft`,
        data: submitedData,
        // headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          console.log(
            '🚀 ~ file: kplhStore.js ~ line 503 ~ .then ~ response',
            response
          )
          state.globalLoading = false
          payload.onSuccess()
        })
        .catch(error => {
          console.log(
            '🚀 ~ file: kplhStore.js ~ line 507 ~ PROCESSING_KPLH ~ error',
            error
          )

          state.globalLoading = false
          store.commit(
            'SET_NOTIF',
            mixin.methods.$get(error, 'response.data.message', 'Error')
          )
        })
    },
    async APPROVE_HEAD_HSE(state, payload) {
      try {
        state.globalLoading = true
        const submitedData = {
          request_id: state.request_id,
          // total_result: state.total_result,
          kplh_note_ah: JSON.stringify({
            note_a_1: state.note_a_1,
            note_a_2: state.note_a_2,
            note_b_1: state.note_b_1,
            note_b_2: state.note_b_2,
            note_b_3: state.note_b_3,
            note_b_4: state.note_b_4,
            note_c_1: state.note_c_1,
            note_c_2: state.note_c_2,
            note_d_1: state.note_d_1,
            note_d_2: state.note_d_2,
            note_e_1: state.note_e_1,
            note_e_2: state.note_e_2,
            note_e_3: state.note_e_3,
            note_f_1: state.note_f_1,
            note_f_2: state.note_f_2,
            note_f_3: state.note_f_3,
            note_f_4: state.note_f_4,
            note_g_1: state.note_g_1,
            note_g_2: state.note_g_2,
            note_g_3: state.note_g_3,
            note_h_1: state.note_h_1,

            internal_note_a_1: state.internal_note_a_1,
            internal_note_a_2: state.internal_note_a_2,
            internal_note_b_1: state.internal_note_b_1,
            internal_note_b_2: state.internal_note_b_2,
            internal_note_b_3: state.internal_note_b_3,
            internal_note_b_4: state.internal_note_b_4,
            internal_note_c_1: state.internal_note_c_1,
            internal_note_c_2: state.internal_note_c_2,
            internal_note_d_1: state.internal_note_d_1,
            internal_note_d_2: state.internal_note_d_2,
            internal_note_e_1: state.internal_note_e_1,
            internal_note_e_2: state.internal_note_e_2,
            internal_note_e_3: state.internal_note_e_3,
            internal_note_f_1: state.internal_note_f_1,
            internal_note_f_2: state.internal_note_f_2,
            internal_note_f_3: state.internal_note_f_3,
            internal_note_f_4: state.internal_note_f_4,
            internal_note_g_1: state.internal_note_g_1,
            internal_note_g_2: state.internal_note_g_2,
            internal_note_g_3: state.internal_note_g_3,
            internal_note_h_1: state.internal_note_h_1,
          }),
          kplh_note_i1: JSON.stringify({
            note_i1_1: state.note_i1_1,
            note_i1_2: state.note_i1_2,
            note_i2_1: state.note_i2_1,
            note_i2_2: state.note_i2_2,
            note_i2_3: state.note_i2_3,
            note_i2_4: state.note_i2_4,
            note_i31_1: state.note_i31_1,
            note_i31_2: state.note_i31_2,
            note_i31_3: state.note_i31_3,
            note_i31_4: state.note_i31_4,
            note_i32_1: state.note_i32_1,
            note_i33_1: state.note_i33_1,
            note_i33_2: state.note_i33_2,
            note_i34_1: state.note_i34_1,
            note_i34_2: state.note_i34_2,
            note_i34_3: state.note_i34_3,
            note_i4_1: state.note_i4_1,
            note_i4_2: state.note_i4_2,
            note_i4_3: state.note_i4_3,

            internal_note_i1_1: state.internal_note_i1_1,
            internal_note_i1_2: state.internal_note_i1_2,
            internal_note_i2_1: state.internal_note_i2_1,
            internal_note_i2_2: state.internal_note_i2_2,
            internal_note_i2_3: state.internal_note_i2_3,
            internal_note_i2_4: state.internal_note_i2_4,
            internal_note_i31_1: state.internal_note_i31_1,
            internal_note_i31_2: state.internal_note_i31_2,
            internal_note_i31_3: state.internal_note_i31_3,
            internal_note_i31_4: state.internal_note_i31_4,
            internal_note_i32_1: state.internal_note_i32_1,
            internal_note_i33_1: state.internal_note_i33_1,
            internal_note_i33_2: state.internal_note_i33_2,
            internal_note_i34_1: state.internal_note_i34_1,
            internal_note_i34_2: state.internal_note_i34_2,
            internal_note_i34_3: state.internal_note_i34_3,
            internal_note_i4_1: state.internal_note_i4_1,
            internal_note_i4_2: state.internal_note_i4_2,
            internal_note_i4_3: state.internal_note_i4_3,
          }),
          kplh_note_i2: JSON.stringify({
            note_i51_1: state.note_i51_1,
            note_i51_2: state.note_i51_2,
            note_i52_1: state.note_i52_1,
            note_i52_2: state.note_i52_2,
            note_i52_3: state.note_i52_3,
            note_i53_1: state.note_i53_1,
            note_i53_2: state.note_i53_2,
            note_i54_1: state.note_i54_1,
            note_i54_2: state.note_i54_2,
            note_i54_3: state.note_i54_3,
            note_i6_1: state.note_i6_1,
            note_i6_2: state.note_i6_2,
            note_i7_1: state.note_i7_1,
            note_i7_2: state.note_i7_2,
            note_i8_1: state.note_i8_1,
            note_i8_2: state.note_i8_2,
            note_i8_3: state.note_i8_3,
            note_i9_1: state.note_i9_1,
            note_i9_2: state.note_i9_2,

            internal_note_i51_1: state.internal_note_i51_1,
            internal_note_i51_2: state.internal_note_i51_2,
            internal_note_i52_1: state.internal_note_i52_1,
            internal_note_i52_2: state.internal_note_i52_2,
            internal_note_i52_3: state.internal_note_i52_3,
            internal_note_i53_1: state.internal_note_i53_1,
            internal_note_i53_2: state.internal_note_i53_2,
            internal_note_i54_1: state.internal_note_i54_1,
            internal_note_i54_2: state.internal_note_i54_2,
            internal_note_i54_3: state.internal_note_i54_3,
            internal_note_i6_1: state.internal_note_i6_1,
            internal_note_i6_2: state.internal_note_i6_2,
            internal_note_i7_1: state.internal_note_i7_1,
            internal_note_i7_2: state.internal_note_i7_2,
            internal_note_i8_1: state.internal_note_i8_1,
            internal_note_i8_2: state.internal_note_i8_2,
            internal_note_i8_3: state.internal_note_i8_3,
            internal_note_i9_1: state.internal_note_i9_1,
            internal_note_i9_2: state.internal_note_i9_2,
          }),
          kplh_note_jm: JSON.stringify({
            note_j_1: state.note_j_1,
            note_j_2: state.note_j_2,
            note_j_3: state.note_j_3,
            note_j_4: state.note_j_4,
            note_k_1: state.note_k_1,
            note_k_2: state.note_k_2,
            note_l_1: state.note_l_1,
            note_l_2: state.note_l_2,
            note_l_3: state.note_l_3,
            note_m_1: state.note_m_1,
            note_m_2: state.note_m_2,
            note_m_3: state.note_m_3,

            internal_note_j_1: state.internal_note_j_1,
            internal_note_j_2: state.internal_note_j_2,
            internal_note_j_3: state.internal_note_j_3,
            internal_note_j_4: state.internal_note_j_4,
            internal_note_k_1: state.internal_note_k_1,
            internal_note_k_2: state.internal_note_k_2,
            internal_note_l_1: state.internal_note_l_1,
            internal_note_l_2: state.internal_note_l_2,
            internal_note_l_3: state.internal_note_l_3,
            internal_note_m_1: state.internal_note_m_1,
            internal_note_m_2: state.internal_note_m_2,
            internal_note_m_3: state.internal_note_m_3,
          }),
          kplh_value_ah: JSON.stringify({
            value_a_1: state.value_a_1,
            value_a_2: state.value_a_2,
            value_b_1: state.value_b_1,
            value_b_2: state.value_b_2,
            value_b_3: state.value_b_3,
            value_b_4: state.value_b_4,
            value_c_1: state.value_c_1,
            value_c_2: state.value_c_2,
            value_d_1: state.value_d_1,
            value_d_2: state.value_d_2,
            value_e_1: state.value_e_1,
            value_e_2: state.value_e_2,
            value_e_3: state.value_e_3,
            value_f_1: state.value_f_1,
            value_f_2: state.value_f_2,
            value_f_3: state.value_f_3,
            value_f_4: state.value_f_4,
            value_g_1: state.value_g_1,
            value_g_2: state.value_g_2,
            value_g_3: state.value_g_3,
            value_h_1: state.value_h_1,
          }),
          kplh_value_i1: JSON.stringify({
            value_i1_1: state.value_i1_1,
            value_i1_2: state.value_i1_2,
            value_i2_1: state.value_i2_1,
            value_i2_2: state.value_i2_2,
            value_i2_3: state.value_i2_3,
            value_i2_4: state.value_i2_4,
            value_i31_1: state.value_i31_1,
            value_i31_2: state.value_i31_2,
            value_i31_3: state.value_i31_3,
            value_i31_4: state.value_i31_4,
            value_i32_1: state.value_i32_1,
            value_i33_1: state.value_i33_1,
            value_i33_2: state.value_i33_2,
            value_i34_1: state.value_i34_1,
            value_i34_2: state.value_i34_2,
            value_i34_3: state.value_i34_3,
            value_i4_1: state.value_i4_1,
            value_i4_2: state.value_i4_2,
            value_i4_3: state.value_i4_3,
          }),
          kplh_value_i2: JSON.stringify({
            value_i51_1: state.value_i51_1,
            value_i51_2: state.value_i51_2,
            value_i52_1: state.value_i52_1,
            value_i52_2: state.value_i52_2,
            value_i52_3: state.value_i52_3,
            value_i53_1: state.value_i53_1,
            value_i53_2: state.value_i53_2,
            value_i54_1: state.value_i54_1,
            value_i54_2: state.value_i54_2,
            value_i54_3: state.value_i54_3,
            value_i6_1: state.value_i6_1,
            value_i6_2: state.value_i6_2,
            value_i7_1: state.value_i7_1,
            value_i7_2: state.value_i7_2,
            value_i8_1: state.value_i8_1,
            value_i8_2: state.value_i8_2,
            value_i8_3: state.value_i8_3,
            value_i9_1: state.value_i9_1,
            value_i9_2: state.value_i9_2,
          }),
          kplh_value_jm: JSON.stringify({
            value_j_1: state.value_j_1,
            value_j_2: state.value_j_2,
            value_j_3: state.value_j_3,
            value_j_4: state.value_j_4,
            value_k_1: state.value_k_1,
            value_k_2: state.value_k_2,
            value_l_1: state.value_l_1,
            value_l_2: state.value_l_2,
            value_l_3: state.value_l_3,
            value_m_1: state.value_m_1,
            value_m_2: state.value_m_2,
            value_m_3: state.value_m_3,
          }),
          total_result: payload.final_result,
          user_id: state.user_id,
          final_result: state.final_result_notes,
          head_hse_id: state.tdd_head_hse,
          ktt_id: state.tdd_ktt,
          catatan: state.catatan,
          posision: 'HSE',
          tingkat_resiko: payload.tingkat_resiko,
          note: '',
        }
        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/request/approve-head-hse/${state.request_id}`,
          data: submitedData,
        })

        if (data && data.status == 'success') {
          state.globalLoading = false
          state.is_kplh_done = true
          state.is_head_approved = true
          store.commit('SET_NOTIF', data.message)
        }
      } catch (error) {
        console.log(
          '🚀 ~ file: ValidationKPLH-HOC.vue ~ line 240 ~ approve ~ error',
          error
        )
        state.globalLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async SIPM_APPROVE_KPLH(state, payload) {
      try {
        state.globalLoading = true

        const submitedData = {
          request_id: state.request_id,
          pic_name: state.pic_name,
          pic_position: state.pic_position,
          pic_phone: state.pic_phone,
          pic_phone_code: state.pic_phone_code,
          pic_email: state.pic_email,
          gems_company: state.choosed_company,
          bidang_usaha_gems: JSON.stringify(state.addedBidangUsahaGems),
          user_id: state.user_id,
          tingkat_resiko: payload.tingkat_resiko,
          kplh_note_ah: JSON.stringify({
            note_a_1: state.note_a_1,
            note_a_2: state.note_a_2,
            note_b_1: state.note_b_1,
            note_b_2: state.note_b_2,
            note_b_3: state.note_b_3,
            note_b_4: state.note_b_4,
            note_c_1: state.note_c_1,
            note_c_2: state.note_c_2,
            note_d_1: state.note_d_1,
            note_d_2: state.note_d_2,
            note_e_1: state.note_e_1,
            note_e_2: state.note_e_2,
            note_e_3: state.note_e_3,
            note_f_1: state.note_f_1,
            note_f_2: state.note_f_2,
            note_f_3: state.note_f_3,
            note_f_4: state.note_f_4,
            note_g_1: state.note_g_1,
            note_g_2: state.note_g_2,
            note_g_3: state.note_g_3,
            note_h_1: state.note_h_1,

            internal_note_a_1: state.internal_note_a_1,
            internal_note_a_2: state.internal_note_a_2,
            internal_note_b_1: state.internal_note_b_1,
            internal_note_b_2: state.internal_note_b_2,
            internal_note_b_3: state.internal_note_b_3,
            internal_note_b_4: state.internal_note_b_4,
            internal_note_c_1: state.internal_note_c_1,
            internal_note_c_2: state.internal_note_c_2,
            internal_note_d_1: state.internal_note_d_1,
            internal_note_d_2: state.internal_note_d_2,
            internal_note_e_1: state.internal_note_e_1,
            internal_note_e_2: state.internal_note_e_2,
            internal_note_e_3: state.internal_note_e_3,
            internal_note_f_1: state.internal_note_f_1,
            internal_note_f_2: state.internal_note_f_2,
            internal_note_f_3: state.internal_note_f_3,
            internal_note_f_4: state.internal_note_f_4,
            internal_note_g_1: state.internal_note_g_1,
            internal_note_g_2: state.internal_note_g_2,
            internal_note_g_3: state.internal_note_g_3,
            internal_note_h_1: state.internal_note_h_1,
          }),
          kplh_note_i1: JSON.stringify({
            note_i1_1: state.note_i1_1,
            note_i1_2: state.note_i1_2,
            note_i2_1: state.note_i2_1,
            note_i2_2: state.note_i2_2,
            note_i2_3: state.note_i2_3,
            note_i2_4: state.note_i2_4,
            note_i31_1: state.note_i31_1,
            note_i31_2: state.note_i31_2,
            note_i31_3: state.note_i31_3,
            note_i31_4: state.note_i31_4,
            note_i32_1: state.note_i32_1,
            note_i33_1: state.note_i33_1,
            note_i33_2: state.note_i33_2,
            note_i34_1: state.note_i34_1,
            note_i34_2: state.note_i34_2,
            note_i34_3: state.note_i34_3,
            note_i4_1: state.note_i4_1,
            note_i4_2: state.note_i4_2,
            note_i4_3: state.note_i4_3,

            internal_note_i1_1: state.internal_note_i1_1,
            internal_note_i1_2: state.internal_note_i1_2,
            internal_note_i2_1: state.internal_note_i2_1,
            internal_note_i2_2: state.internal_note_i2_2,
            internal_note_i2_3: state.internal_note_i2_3,
            internal_note_i2_4: state.internal_note_i2_4,
            internal_note_i31_1: state.internal_note_i31_1,
            internal_note_i31_2: state.internal_note_i31_2,
            internal_note_i31_3: state.internal_note_i31_3,
            internal_note_i31_4: state.internal_note_i31_4,
            internal_note_i32_1: state.internal_note_i32_1,
            internal_note_i33_1: state.internal_note_i33_1,
            internal_note_i33_2: state.internal_note_i33_2,
            internal_note_i34_1: state.internal_note_i34_1,
            internal_note_i34_2: state.internal_note_i34_2,
            internal_note_i34_3: state.internal_note_i34_3,
            internal_note_i4_1: state.internal_note_i4_1,
            internal_note_i4_2: state.internal_note_i4_2,
            internal_note_i4_3: state.internal_note_i4_3,
          }),
          kplh_note_i2: JSON.stringify({
            note_i51_1: state.note_i51_1,
            note_i51_2: state.note_i51_2,
            note_i52_1: state.note_i52_1,
            note_i52_2: state.note_i52_2,
            note_i52_3: state.note_i52_3,
            note_i53_1: state.note_i53_1,
            note_i53_2: state.note_i53_2,
            note_i54_1: state.note_i54_1,
            note_i54_2: state.note_i54_2,
            note_i54_3: state.note_i54_3,
            note_i6_1: state.note_i6_1,
            note_i6_2: state.note_i6_2,
            note_i7_1: state.note_i7_1,
            note_i7_2: state.note_i7_2,
            note_i8_1: state.note_i8_1,
            note_i8_2: state.note_i8_2,
            note_i8_3: state.note_i8_3,
            note_i9_1: state.note_i9_1,
            note_i9_2: state.note_i9_2,

            internal_note_i51_1: state.internal_note_i51_1,
            internal_note_i51_2: state.internal_note_i51_2,
            internal_note_i52_1: state.internal_note_i52_1,
            internal_note_i52_2: state.internal_note_i52_2,
            internal_note_i52_3: state.internal_note_i52_3,
            internal_note_i53_1: state.internal_note_i53_1,
            internal_note_i53_2: state.internal_note_i53_2,
            internal_note_i54_1: state.internal_note_i54_1,
            internal_note_i54_2: state.internal_note_i54_2,
            internal_note_i54_3: state.internal_note_i54_3,
            internal_note_i6_1: state.internal_note_i6_1,
            internal_note_i6_2: state.internal_note_i6_2,
            internal_note_i7_1: state.internal_note_i7_1,
            internal_note_i7_2: state.internal_note_i7_2,
            internal_note_i8_1: state.internal_note_i8_1,
            internal_note_i8_2: state.internal_note_i8_2,
            internal_note_i8_3: state.internal_note_i8_3,
            internal_note_i9_1: state.internal_note_i9_1,
            internal_note_i9_2: state.internal_note_i9_2,
          }),
          kplh_note_jm: JSON.stringify({
            note_j_1: state.note_j_1,
            note_j_2: state.note_j_2,
            note_j_3: state.note_j_3,
            note_j_4: state.note_j_4,
            note_k_1: state.note_k_1,
            note_k_2: state.note_k_2,
            note_l_1: state.note_l_1,
            note_l_2: state.note_l_2,
            note_l_3: state.note_l_3,
            note_m_1: state.note_m_1,
            note_m_2: state.note_m_2,
            note_m_3: state.note_m_3,

            internal_note_j_1: state.internal_note_j_1,
            internal_note_j_2: state.internal_note_j_2,
            internal_note_j_3: state.internal_note_j_3,
            internal_note_j_4: state.internal_note_j_4,
            internal_note_k_1: state.internal_note_k_1,
            internal_note_k_2: state.internal_note_k_2,
            internal_note_l_1: state.internal_note_l_1,
            internal_note_l_2: state.internal_note_l_2,
            internal_note_l_3: state.internal_note_l_3,
            internal_note_m_1: state.internal_note_m_1,
            internal_note_m_2: state.internal_note_m_2,
            internal_note_m_3: state.internal_note_m_3,
          }),
        }

        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/request/approve-kplh/${state.request_id}`,
          data: submitedData,
        })

        if (data && data.status == 'success') {
          state.globalLoading = false
          state.is_sipm_validation = false
          store.commit('SET_NOTIF', 'Submit Data KPLH Berhasil!')
        }
      } catch (error) {
        console.log('error sipm approve: ', error)
        state.globalLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async NEED_REVIEW_HEAD(state, payload) {
      try {
        state.globalLoading = true
        const submitedData = {
          request_id: state.request_id,
          kplh_note_ah: JSON.stringify({
            note_a_1: state.note_a_1,
            note_a_2: state.note_a_2,
            note_b_1: state.note_b_1,
            note_b_2: state.note_b_2,
            note_b_3: state.note_b_3,
            note_b_4: state.note_b_4,
            note_c_1: state.note_c_1,
            note_c_2: state.note_c_2,
            note_d_1: state.note_d_1,
            note_d_2: state.note_d_2,
            note_e_1: state.note_e_1,
            note_e_2: state.note_e_2,
            note_e_3: state.note_e_3,
            note_f_1: state.note_f_1,
            note_f_2: state.note_f_2,
            note_f_3: state.note_f_3,
            note_f_4: state.note_f_4,
            note_g_1: state.note_g_1,
            note_g_2: state.note_g_2,
            note_g_3: state.note_g_3,
            note_h_1: state.note_h_1,

            internal_note_a_1: state.internal_note_a_1,
            internal_note_a_2: state.internal_note_a_2,
            internal_note_b_1: state.internal_note_b_1,
            internal_note_b_2: state.internal_note_b_2,
            internal_note_b_3: state.internal_note_b_3,
            internal_note_b_4: state.internal_note_b_4,
            internal_note_c_1: state.internal_note_c_1,
            internal_note_c_2: state.internal_note_c_2,
            internal_note_d_1: state.internal_note_d_1,
            internal_note_d_2: state.internal_note_d_2,
            internal_note_e_1: state.internal_note_e_1,
            internal_note_e_2: state.internal_note_e_2,
            internal_note_e_3: state.internal_note_e_3,
            internal_note_f_1: state.internal_note_f_1,
            internal_note_f_2: state.internal_note_f_2,
            internal_note_f_3: state.internal_note_f_3,
            internal_note_f_4: state.internal_note_f_4,
            internal_note_g_1: state.internal_note_g_1,
            internal_note_g_2: state.internal_note_g_2,
            internal_note_g_3: state.internal_note_g_3,
            internal_note_h_1: state.internal_note_h_1,
          }),
          kplh_note_i1: JSON.stringify({
            note_i1_1: state.note_i1_1,
            note_i1_2: state.note_i1_2,
            note_i2_1: state.note_i2_1,
            note_i2_2: state.note_i2_2,
            note_i2_3: state.note_i2_3,
            note_i2_4: state.note_i2_4,
            note_i31_1: state.note_i31_1,
            note_i31_2: state.note_i31_2,
            note_i31_3: state.note_i31_3,
            note_i31_4: state.note_i31_4,
            note_i32_1: state.note_i32_1,
            note_i33_1: state.note_i33_1,
            note_i33_2: state.note_i33_2,
            note_i34_1: state.note_i34_1,
            note_i34_2: state.note_i34_2,
            note_i34_3: state.note_i34_3,
            note_i4_1: state.note_i4_1,
            note_i4_2: state.note_i4_2,
            note_i4_3: state.note_i4_3,

            internal_note_i1_1: state.internal_note_i1_1,
            internal_note_i1_2: state.internal_note_i1_2,
            internal_note_i2_1: state.internal_note_i2_1,
            internal_note_i2_2: state.internal_note_i2_2,
            internal_note_i2_3: state.internal_note_i2_3,
            internal_note_i2_4: state.internal_note_i2_4,
            internal_note_i31_1: state.internal_note_i31_1,
            internal_note_i31_2: state.internal_note_i31_2,
            internal_note_i31_3: state.internal_note_i31_3,
            internal_note_i31_4: state.internal_note_i31_4,
            internal_note_i32_1: state.internal_note_i32_1,
            internal_note_i33_1: state.internal_note_i33_1,
            internal_note_i33_2: state.internal_note_i33_2,
            internal_note_i34_1: state.internal_note_i34_1,
            internal_note_i34_2: state.internal_note_i34_2,
            internal_note_i34_3: state.internal_note_i34_3,
            internal_note_i4_1: state.internal_note_i4_1,
            internal_note_i4_2: state.internal_note_i4_2,
            internal_note_i4_3: state.internal_note_i4_3,
          }),
          kplh_note_i2: JSON.stringify({
            note_i51_1: state.note_i51_1,
            note_i51_2: state.note_i51_2,
            note_i52_1: state.note_i52_1,
            note_i52_2: state.note_i52_2,
            note_i52_3: state.note_i52_3,
            note_i53_1: state.note_i53_1,
            note_i53_2: state.note_i53_2,
            note_i54_1: state.note_i54_1,
            note_i54_2: state.note_i54_2,
            note_i54_3: state.note_i54_3,
            note_i6_1: state.note_i6_1,
            note_i6_2: state.note_i6_2,
            note_i7_1: state.note_i7_1,
            note_i7_2: state.note_i7_2,
            note_i8_1: state.note_i8_1,
            note_i8_2: state.note_i8_2,
            note_i8_3: state.note_i8_3,
            note_i9_1: state.note_i9_1,
            note_i9_2: state.note_i9_2,

            internal_note_i51_1: state.internal_note_i51_1,
            internal_note_i51_2: state.internal_note_i51_2,
            internal_note_i52_1: state.internal_note_i52_1,
            internal_note_i52_2: state.internal_note_i52_2,
            internal_note_i52_3: state.internal_note_i52_3,
            internal_note_i53_1: state.internal_note_i53_1,
            internal_note_i53_2: state.internal_note_i53_2,
            internal_note_i54_1: state.internal_note_i54_1,
            internal_note_i54_2: state.internal_note_i54_2,
            internal_note_i54_3: state.internal_note_i54_3,
            internal_note_i6_1: state.internal_note_i6_1,
            internal_note_i6_2: state.internal_note_i6_2,
            internal_note_i7_1: state.internal_note_i7_1,
            internal_note_i7_2: state.internal_note_i7_2,
            internal_note_i8_1: state.internal_note_i8_1,
            internal_note_i8_2: state.internal_note_i8_2,
            internal_note_i8_3: state.internal_note_i8_3,
            internal_note_i9_1: state.internal_note_i9_1,
            internal_note_i9_2: state.internal_note_i9_2,
          }),
          kplh_note_jm: JSON.stringify({
            note_j_1: state.note_j_1,
            note_j_2: state.note_j_2,
            note_j_3: state.note_j_3,
            note_j_4: state.note_j_4,
            note_k_1: state.note_k_1,
            note_k_2: state.note_k_2,
            note_l_1: state.note_l_1,
            note_l_2: state.note_l_2,
            note_l_3: state.note_l_3,
            note_m_1: state.note_m_1,
            note_m_2: state.note_m_2,
            note_m_3: state.note_m_3,

            internal_note_j_1: state.internal_note_j_1,
            internal_note_j_2: state.internal_note_j_2,
            internal_note_j_3: state.internal_note_j_3,
            internal_note_j_4: state.internal_note_j_4,
            internal_note_k_1: state.internal_note_k_1,
            internal_note_k_2: state.internal_note_k_2,
            internal_note_l_1: state.internal_note_l_1,
            internal_note_l_2: state.internal_note_l_2,
            internal_note_l_3: state.internal_note_l_3,
            internal_note_m_1: state.internal_note_m_1,
            internal_note_m_2: state.internal_note_m_2,
            internal_note_m_3: state.internal_note_m_3,
          }),
          kplh_value_ah: JSON.stringify({
            value_a_1: state.value_a_1,
            value_a_2: state.value_a_2,
            value_b_1: state.value_b_1,
            value_b_2: state.value_b_2,
            value_b_3: state.value_b_3,
            value_b_4: state.value_b_4,
            value_c_1: state.value_c_1,
            value_c_2: state.value_c_2,
            value_d_1: state.value_d_1,
            value_d_2: state.value_d_2,
            value_e_1: state.value_e_1,
            value_e_2: state.value_e_2,
            value_e_3: state.value_e_3,
            value_f_1: state.value_f_1,
            value_f_2: state.value_f_2,
            value_f_3: state.value_f_3,
            value_f_4: state.value_f_4,
            value_g_1: state.value_g_1,
            value_g_2: state.value_g_2,
            value_g_3: state.value_g_3,
            value_h_1: state.value_h_1,
          }),
          kplh_value_i1: JSON.stringify({
            value_i1_1: state.value_i1_1,
            value_i1_2: state.value_i1_2,
            value_i2_1: state.value_i2_1,
            value_i2_2: state.value_i2_2,
            value_i2_3: state.value_i2_3,
            value_i2_4: state.value_i2_4,
            value_i31_1: state.value_i31_1,
            value_i31_2: state.value_i31_2,
            value_i31_3: state.value_i31_3,
            value_i31_4: state.value_i31_4,
            value_i32_1: state.value_i32_1,
            value_i33_1: state.value_i33_1,
            value_i33_2: state.value_i33_2,
            value_i34_1: state.value_i34_1,
            value_i34_2: state.value_i34_2,
            value_i34_3: state.value_i34_3,
            value_i4_1: state.value_i4_1,
            value_i4_2: state.value_i4_2,
            value_i4_3: state.value_i4_3,
          }),
          kplh_value_i2: JSON.stringify({
            value_i51_1: state.value_i51_1,
            value_i51_2: state.value_i51_2,
            value_i52_1: state.value_i52_1,
            value_i52_2: state.value_i52_2,
            value_i52_3: state.value_i52_3,
            value_i53_1: state.value_i53_1,
            value_i53_2: state.value_i53_2,
            value_i54_1: state.value_i54_1,
            value_i54_2: state.value_i54_2,
            value_i54_3: state.value_i54_3,
            value_i6_1: state.value_i6_1,
            value_i6_2: state.value_i6_2,
            value_i7_1: state.value_i7_1,
            value_i7_2: state.value_i7_2,
            value_i8_1: state.value_i8_1,
            value_i8_2: state.value_i8_2,
            value_i8_3: state.value_i8_3,
            value_i9_1: state.value_i9_1,
            value_i9_2: state.value_i9_2,
          }),
          kplh_value_jm: JSON.stringify({
            value_j_1: state.value_j_1,
            value_j_2: state.value_j_2,
            value_j_3: state.value_j_3,
            value_j_4: state.value_j_4,
            value_k_1: state.value_k_1,
            value_k_2: state.value_k_2,
            value_l_1: state.value_l_1,
            value_l_2: state.value_l_2,
            value_l_3: state.value_l_3,
            value_m_1: state.value_m_1,
            value_m_2: state.value_m_2,
            value_m_3: state.value_m_3,
          }),

          total_result: payload.final_result,
          user_id: state.user_id,
          final_result: state.final_result_notes,
          catatan: state.catatan,
          tingkat_resiko: payload.tingkat_resiko,
          note: payload.note,
        }
        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/request/review-head-hse/${payload.id}`,
          data: submitedData,
        })

        if (data && data.status == 'success') {
          state.globalLoading = false
          state.is_catatan_head_open = false
          state.is_kplh_done = true
          state.is_head_approved = true
          store.commit('SET_NOTIF', data.message)
        }
      } catch (error) {
        console.log(
          '🚀 ~ file: ValidationKPLH-HOC.vue ~ line 240 ~ approve ~ error',
          error
        )
        state.globalLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
  },
}

export default kplhStore
